/* ───────────────────────────────────────────────────────────────────────────
   GSG SHARED HELPERS - Must load before any brand widget.
   Attached to window so all brand widgets can reach them regardless of scope.
   ─────────────────────────────────────────────────────────────────────────── */

/* GSG 2026-08-20 v2: quantity-aware Add-to-Cart button label.
   The button must never understate the amount about to be added, and it
   must reproduce the REAL pricing semantics proven against the live rate
   engine on 2026-08-20:
     merchandise            x qty
     base freight (FPIA)    x qty        (300->600, 405->810 proven)
     residential/liftgate   flat per order  (katool $80: 380@1 -> 680@2 proven;
                                             free-base $80@1 = $80@2 proven;
                                             NAT res_la $150: 555@1 -> 960@2 proven)
     area rural             flat per order  ($200: 605@1 -> 1010@2 proven)
     area city              fee_first + fee_additional x (qty-1)
                                            ($200+$100: 605@1 -> 1110@2 proven)
   NEVER multiply a finished single-unit total by quantity - fees are not
   linear. Per-unit price displays (priceEl) stay per-unit. Display-only:
   no property, attribute, or rate contract is touched. Legacy BendPak /
   Triumph modules are deliberately NOT quantity-aware (zero active
   products use their templates; semantics unproven).
   Quantity is resolved inside the widget's own product form first so a
   sticky form or future secondary input cannot hijack the value. */
function gsgQtyFor(el) {
  var scope = null;
  if (el && el.closest) {
    scope = el.closest('form[action*="/cart/add"]') || el.closest('product-info') || el.closest('.product');
  }
  var q = (scope && scope.querySelector('input[name="quantity"], .quantity__input')) ||
          document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"], .quantity__input');
  var v = q ? parseInt(q.value, 10) : 1;
  return (v && v > 0) ? v : 1;
}
function gsgWireQtyRefresh(el, fn) {
  var scope = null;
  if (el && el.closest) {
    scope = el.closest('form[action*="/cart/add"]') || el.closest('product-info') || el.closest('.product');
  }
  var q = (scope && scope.querySelector('input[name="quantity"], .quantity__input')) ||
          document.querySelector('form[action*="/cart/add"] input[name="quantity"], input[name="quantity"], .quantity__input');
  if (!q || q.dataset.gsgQtyWired) return;
  q.dataset.gsgQtyWired = '1';
  ['change','input'].forEach(function(ev){ q.addEventListener(ev, fn); });
}
function gsgMoney(n) {
  return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/* SELECTED-VARIANT PRICE (2026-08-26).
   `product.price` in Liquid is the LOWEST variant price, not the one the shopper
   is looking at. The widgets used to capture it once and stamp it over the real
   price on every updatePrice(), so a multi-variant product quoted its cheapest
   variant, and it re-broke every time the shopper answered a delivery question.
   This reads the price of the variant actually selected, right now, and falls
   back to the old value when there is no map or no match. */
window.gsgLivePrice = function (wrapper, fallback) {
  try {
    var raw = wrapper && wrapper.dataset ? (wrapper.dataset.variantPrices || '') : '';
    if (!raw) return fallback;
    /* Prefer the section-scoped real-form resolver (defined below at
       runtime); the bare selector remains only as a bootstrap fallback. */
    var form = window.gsgProductForm ? window.gsgProductForm(wrapper)
                                     : document.querySelector('form[action="/cart/add"]');
    var input = form ? (form.querySelector('[name="id"]')) : null;
    if (!input || !input.value) return fallback;
    var m = String(input.value).match(/(\d+)\s*$/);
    if (!m) return fallback;
    var want = m[1], parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split(':');
      if (kv[0] === want) {
        var p = parseFloat(kv[1]);
        return (isFinite(p) && p > 0) ? p : fallback;
      }
    }
  } catch (e) { /* never break the widget over a price lookup */ }
  return fallback;
};

window.gsgSetCartButtonState = function(addToCartBtn, enabled) {
  if (!addToCartBtn) return;
  addToCartBtn.setAttribute('aria-disabled', String(!enabled));
  if (enabled) {
    addToCartBtn.classList.remove('gsg-cart-locked');
  } else {
    addToCartBtn.classList.add('gsg-cart-locked');
  }
  // Hide dynamic checkout buttons (Shop Pay, PayPal, Affirm) until ready
  var dynamicCheckoutSelectors = [
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    '.product-form__buttons .shopify-payment-button',
    '.shopify-payment-button__button'
  ];
  dynamicCheckoutSelectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el) {
      if (enabled) {
        el.classList.remove('gsg-dynamic-checkout-hidden');
      } else {
        el.classList.add('gsg-dynamic-checkout-hidden');
      }
    });
  });
};

// Single-widget guard. First widget to fire wins; others bail.
// Prevents double-attached click handlers if a product accidentally has
// multiple brand metafields.
window.gsgClaimWidget = function(addToCartBtn, widgetName) {
  if (!addToCartBtn) return true; // Nothing to guard, proceed normally
  if (addToCartBtn.dataset.gsgWidgetAttached) {
    console.warn('[GSG] ' + widgetName + ' widget skipped: ' + addToCartBtn.dataset.gsgWidgetAttached + ' already attached.');
    return false;
  }
  addToCartBtn.dataset.gsgWidgetAttached = widgetName;
  return true;
};

/* RELEASE 1 (2026-08-31): purchase-contract repair - shared, section-scoped
   helpers. Branch question trees, formulas, and payload semantics stay
   branch-owned; these only fix HOW each branch finds the DOM, writes the
   configured price, hears variant changes, and collects selected add-ons. */
window.GSG_WIDGET_VERSION = 'R1.7-2026-08-31';
try { console.info('[GSG] delivery widget ' + window.GSG_WIDGET_VERSION); } catch (e) {}

/* bfcache safety: the add-to-cart latch (data-gsg-adding) is cleared in the
   fetch error path, but a successful add navigates to /cart - pressing Back
   can restore this page from the back-forward cache with the latch still
   set, leaving Add to Cart permanently dead. Clear it on every restore. */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  document.querySelectorAll('[data-gsg-adding]').forEach(function (el) {
    delete el.dataset.gsgAdding;
  });
});

/* The main-product section that contains this widget wrapper. */
window.gsgSectionScope = function (wrapper) {
  return (wrapper && wrapper.closest &&
    (wrapper.closest('.shopify-section') || wrapper.closest('product-info'))) || document;
};

/* The native product form that owns Add to Cart, scoped to the widget's
   section first so a featured-product section or modal never hijacks it. */
window.gsgProductForm = function (wrapper) {
  var scope = window.gsgSectionScope(wrapper);
  /* The Shop Pay installments form ALSO has action="/cart/add" and sits
     EARLIER in the DOM (id "ProductFormInstallment-…"), so a bare
     first-match grabs the wrong form and the bundle checkboxes' form
     association never matches. Prefer Concept's real form, whose id is
     "ProductForm-<section>-<product>" (the hyphen excludes the
     installment id, which continues with "Installment"). */
  return scope.querySelector('form[action="/cart/add"][id^="ProductForm-"]') ||
         document.querySelector('form[action="/cart/add"][id^="ProductForm-"]') ||
         scope.querySelector('form[action="/cart/add"]') ||
         scope.querySelector('product-form form') ||
         document.querySelector('form[action="/cart/add"]') ||
         document.querySelector('product-form form') ||
         document.querySelector('.product-form form');
};

/* Selected variant id, read the way a NATIVE submit would: FormData honors
   controls associated via the form="" attribute (Concept's variant <select>
   lives OUTSIDE the form element) and excludes disabled controls (the
   form's inner hidden id input is disabled on multi-variant products).
   querySelector fallbacks cover single-variant and legacy markup. */
window.gsgSelectedVariantId = function (form) {
  var raw = null;
  try {
    if (form && window.FormData) raw = new FormData(form).get('id');
  } catch (e) { /* fall through to element reads */ }
  if (!raw && form) {
    var inp = form.querySelector('input[name="id"]:not([disabled])') ||
              form.querySelector('select[name="id"]') ||
              form.querySelector('input[name="id"]');
    raw = inp ? inp.value : null;
  }
  var m = raw ? String(raw).match(/(\d+)\s*$/) : null;
  return m ? parseInt(m[1], 10) : null;
};

/* Write ONLY the visible current-price text. Concept replaces the CHILDREN of
   the #Price-… container via innerHTML on every valid variant change, so the
   inner .price__regular span MUST be re-queried on every write - never cached.
   Siblings are never touched: .price__sale compare-at, sr-only labels,
   .unit-price, volume notes, and the payment-terms form all survive. */
window.gsgWritePrice = function (wrapper, formatted, composite) {
  var scope = window.gsgSectionScope(wrapper);
  var container = scope.querySelector('[id^="Price-"]') || scope.querySelector('.product__price');
  if (!container) return;
  var target = container.querySelector('.price__regular');
  if (target) target.textContent = formatted;
  /* composite = the written amount is NOT the bare variant price (freight,
     fees, or add-ons folded in). The native compare-at then no longer
     relates to the shown number, so it is hidden - a raised price must
     never render above its own strikethrough. */
  var priceFlex = container.querySelector('.price');
  if (priceFlex) priceFlex.classList.toggle('gsg-composite-price', !!composite);
};

/* Selected "Popular Add-ons" bundle checkboxes - the SINGLE source of truth
   for cart payload items, button total, and the price note, so the three
   surfaces can never disagree. Mirrors Concept's own reader (theme.js
   ProductForm.bundles): the <details is="product-bundle-details"> ancestor
   carries form="<form id>"; the checkboxes need no form attribute.
   getAttribute('id'), never form.id: the form contains <input name="id">,
   and named controls SHADOW form properties - form.id returns that input
   element, which stringifies to "[object HTMLInputElement]" in a selector. */
window.gsgSelectedAddons = function (wrapper) {
  var out = { items: [], cents: 0, count: 0 };
  var form = window.gsgProductForm(wrapper);
  var formId = form ? form.getAttribute('id') : null;
  if (!formId) return out;
  var boxes = document.querySelectorAll('[form="' + formId + '"] input[name="bundles"]:checked');
  for (var i = 0; i < boxes.length; i++) {
    var id = parseInt(boxes[i].value, 10);
    if (!(id > 0)) continue;
    out.items.push({ id: id, quantity: 1 });
    out.cents += parseInt(boxes[i].dataset.price, 10) || 0;
    out.count++;
  }
  return out;
};
window.gsgCollectBundles = function (wrapper) {
  return window.gsgSelectedAddons(wrapper).items;
};

/* Dollar total of the selected add-ons. Convenience wrapper over
   gsgSelectedAddons for callers that only need the amount. */
window.gsgBundleTotal = function (wrapper) {
  return window.gsgSelectedAddons(wrapper).cents / 100;
};

/* Small indicator in the price stack naming the selected add-ons; removed
   when nothing is selected. Pass the gsgSelectedAddons result to avoid a
   re-scan; without it the helper resolves its own.
   DURABILITY NOTE: the note lives INSIDE #Price-…, whose children Concept
   replaces via innerHTML on every valid variant change. It survives only
   because the variantChange subscription re-runs updatePrice, which
   re-renders it - keep that call when refactoring. */
window.gsgRenderAddonNote = function (wrapper, addons) {
  var scope = window.gsgSectionScope(wrapper);
  var container = scope.querySelector('[id^="Price-"]') || scope.querySelector('.product__price');
  if (!container) return;
  var priceFlex = container.querySelector('.price') || container;
  if (!addons) addons = window.gsgSelectedAddons(wrapper);
  var note = priceFlex.querySelector('.gsg-addon-note');
  if (!addons.count) {
    if (note) note.remove();
    return;
  }
  if (!note) {
    note = document.createElement('span');
    note.className = 'gsg-addon-note';
    priceFlex.appendChild(note);
  }
  note.textContent = 'Includes ' + (addons.count === 1 ? '1 add-on' : addons.count + ' add-ons') + ' (+ ' + gsgMoney(addons.cents / 100) + ')';
};

/* Re-run the widget's price recompute when an add-on checkbox toggles.
   Concept dispatches 'bundle:change' on the product form (non-bubbling);
   native ProductBuyPrice attaches first, so the widget's write wins the race.
   Once-guarded like gsgWireQtyRefresh. */
window.gsgWireBundleRefresh = function (wrapper, fn) {
  var form = window.gsgProductForm(wrapper);
  if (!form || form.dataset.gsgBundleWired) return;
  form.dataset.gsgBundleWired = '1';
  form.addEventListener('bundle:change', fn);
};

/* Variant-change subscription. Concept's 'variant:change' CustomEvent does NOT
   bubble (it is dispatched on the product form), so document-level listeners
   never hear it - the reliable channel is Concept's pubsub. theme.js is
   deferred ahead of this file, so theme.pubsub exists by DOMContentLoaded; the
   retry guard covers any ordering slip. Concept publishes ONLY for a valid
   resolved variant ({data:{sectionId, productId, variant}}); invalid option
   combinations publish nothing, matching native behavior. */
window.gsgOnVariantChange = function (cb) {
  var tries = 0;
  (function attach() {
    if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
      var evt = (window.theme.pubsub.PUB_SUB_EVENTS && window.theme.pubsub.PUB_SUB_EVENTS.variantChange) || 'variantChange';
      window.theme.pubsub.subscribe(evt, cb);
    } else if (tries++ < 20) {
      setTimeout(attach, 250);
    }
  })();
};

/* ================= WIDGET TREE V1 =================
   Foundation above this line. Every brand below is its OWN branch.
   Doctrine (shipping/WIDGET-TREE-V1.md): branches never share code,
   config, or metafields with each other - repetition is deliberate.
   The shared inventory reader below is foundation (pure readers of
   the #gsg-inventory-data script tag; used by the katool family). */
/* KATOOL DELIVERY WIDGET - PATH A (PICKUP CREDIT MODEL) + STOCK INDICATOR */

/* KATOOL INVENTORY - sourced from VARIANT METAFIELDS (katool-inventory-sync
   skill -> Matrixify import -> template emits #gsg-inventory-data JSON).
   The old hardcoded stock table and in-file SKU alias map are gone. This
   layer is BRAND-AGNOSTIC: any vendor whose variants carry the same
   metafields (inventory_status, supplier_reported_qty, pickup_inventory,
   pickup_inventory_updated_at) lights up identically. */
const KATOOL_LOW_STOCK = 3;

const gsgInventoryData = (function () {
  const el = document.getElementById('gsg-inventory-data');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
})();

function gsgVariantInventory(variantId) {
  if (!gsgInventoryData || !variantId) return null;
  const v = gsgInventoryData.variants && gsgInventoryData.variants[String(variantId)];
  if (!v) return null;
  return {
    status: v.status || null,
    qty: (typeof v.qty === 'number') ? v.qty : null,
    pickup: v.pickup || {},
    discontinued: v.pool === 'discontinued'
  };
}

function gsgRegistryEntry(key) {
  return (gsgInventoryData && gsgInventoryData.registry && gsgInventoryData.registry[key]) || null;
}

/* Up-front pickup availability line. Names are deduped because several
   registry keys share a city (two Houston, two Denver, two Linden blocks);
   the customer sees the city once, the dropdown still lists each address. */
function gsgPickupSummaryText(list) {
  const names = [];
  list.forEach(function (i) { if (names.indexOf(i.reg.name) === -1) names.push(i.reg.name); });
  if (!names.length) return '';
  if (names.length === 1) return 'In stock for pickup at ' + names[0];
  const rest = names.length - 3;
  return 'In stock for pickup at ' + names.length + ' warehouses: ' +
         names.slice(0, 3).join(', ') + (rest > 0 ? ' and ' + rest + ' more' : '');
}

function gsgPickupList(inv) {
  // Customer-eligible pickup: in-stock, registry-known warehouses only.
  // Zero-stock warehouses are HIDDEN by design.
  if (!inv) return [];
  return Object.keys(inv.pickup)
    .filter(function (k) { return inv.pickup[k] > 0 && gsgRegistryEntry(k); })
    .map(function (k) { return { key: k, qty: inv.pickup[k], reg: gsgRegistryEntry(k) }; })
    .sort(function (a, b) { return a.reg.name.localeCompare(b.reg.name); });
}

/* ============ BRANCH katool_v1 - Katool: charges, pickup network, inventory, credits ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="katool_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  /* RELEASE 1: no cached price node - writes go through gsgWritePrice, which
     re-queries inside this section on every call (Concept swaps the container's
     children on variant change). buttonPriceEl is the #BuyButtonPrice container
     itself; Concept replaces its children, not the node, so caching it is safe. */
  const buttonPriceEl = window.gsgSectionScope(wrapper).querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = window.gsgProductForm(wrapper);

  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'katool_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = 'In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = 'Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = 'Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = 'Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    /* Displayed price includes selected add-ons (Jordan 2026-08-31): one
       number that matches what Add to Cart will add. Whenever that number
       is not the bare variant price (fees or add-ons folded in), the
       compare-at is hidden via the composite flag so a raised price never
       renders above its own strikethrough. */
    const gsgAddons = window.gsgSelectedAddons(wrapper);
    const gsgShown = total + gsgAddons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(gsgShown), gsgShown !== basePrice);
    window.gsgRenderAddonNote(wrapper, gsgAddons);
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      /* Selected add-ons are real items in the widget's add - the button
         total must never understate the amount about to be added. */
      gsgBtn += gsgAddons.cents / 100;
      window.gsgWireBundleRefresh(wrapper, updatePrice);
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  /* RELEASE 1: this used to listen for 'variant:changed', an event nothing in
     the theme ever dispatches (Concept's 'variant:change' does not bubble past
     the form). Subscribed to Concept's pubsub instead - the channel Concept
     actually publishes valid variant changes on. */
  window.gsgOnVariantChange(function(payload) {
    const variant = payload && payload.data && payload.data.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
      /* Concept just restored native price markup for the new variant;
         re-apply the configured total on top of the fresh base price. */
      updatePrice();
    }
  });

  /* No form-input fallback listener here: theme.js updateVariantInputs
     dispatches synthetic 'change' on the form's id inputs AND then publishes
     variantChange - listening to both ran every variant update twice. The
     pubsub subscription above is the single variant channel. */

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantId = toVariantId(window.gsgSelectedVariantId(productForm));

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      /* RELEASE 1: selected Popular Add-ons ride along as real cart items -
         previously ticked add-ons were silently dropped by this custom add. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });

      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding;
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* ============ BRANCH fortisky_v1 - Fortisky: charges + Virginia Beach pickup ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="fortisky_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  /* RELEASE 1: no cached price node - writes go through gsgWritePrice, which
     re-queries inside this section on every call (Concept swaps the container's
     children on variant change). buttonPriceEl is the #BuyButtonPrice container
     itself; Concept replaces its children, not the node, so caching it is safe. */
  const buttonPriceEl = window.gsgSectionScope(wrapper).querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = window.gsgProductForm(wrapper);

  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'fortisky_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = 'In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = 'Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = 'Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = 'Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    /* Displayed price includes selected add-ons (Jordan 2026-08-31): one
       number that matches what Add to Cart will add. Whenever that number
       is not the bare variant price (fees or add-ons folded in), the
       compare-at is hidden via the composite flag so a raised price never
       renders above its own strikethrough. */
    const gsgAddons = window.gsgSelectedAddons(wrapper);
    const gsgShown = total + gsgAddons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(gsgShown), gsgShown !== basePrice);
    window.gsgRenderAddonNote(wrapper, gsgAddons);
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      /* Selected add-ons are real items in the widget's add - the button
         total must never understate the amount about to be added. */
      gsgBtn += gsgAddons.cents / 100;
      window.gsgWireBundleRefresh(wrapper, updatePrice);
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  /* RELEASE 1: this used to listen for 'variant:changed', an event nothing in
     the theme ever dispatches (Concept's 'variant:change' does not bubble past
     the form). Subscribed to Concept's pubsub instead - the channel Concept
     actually publishes valid variant changes on. */
  window.gsgOnVariantChange(function(payload) {
    const variant = payload && payload.data && payload.data.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
      /* Concept just restored native price markup for the new variant;
         re-apply the configured total on top of the fresh base price. */
      updatePrice();
    }
  });

  /* No form-input fallback listener here: theme.js updateVariantInputs
     dispatches synthetic 'change' on the form's id inputs AND then publishes
     variantChange - listening to both ran every variant update twice. The
     pubsub subscription above is the single variant channel. */

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantId = toVariantId(window.gsgSelectedVariantId(productForm));

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      /* RELEASE 1: selected Popular Add-ons ride along as real cart items -
         previously ticked add-ons were silently dropped by this custom add. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });

      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding;
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* ============ BRANCH challenger_v1 - Challenger: free everything (revocable here, one-branch change) ============
   Widget Tree V1 (2026-08-27). OWN BRANCH - edit freely, no other
   brand shares this code. Grown from the katool family module. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="challenger_v1"]');
  if (!wrapper) return;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const locationSelect = wrapper.querySelector('#pickup-location');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  const stockBadge = wrapper.querySelector('.gsg-stock-badge');
  const stockWhere = wrapper.querySelector('.gsg-stock-where');

  /* The warehouse line is a POSITIVE claim, so it renders only from the same
     gate the pickup dropdown uses: fresh data, in-stock, registry-known
     warehouses. Stale, unknown, or discontinued -> nothing is claimed. */
  function updatePickupSummary(list) {
    if (!stockWhere) return;
    const txt = gsgPickupSummaryText(list || []);
    stockWhere.textContent = txt;
    stockWhere.style.display = txt ? 'block' : 'none';
  }

  /* RELEASE 1: no cached price node - writes go through gsgWritePrice, which
     re-queries inside this section on every call (Concept swaps the container's
     children on variant change). buttonPriceEl is the #BuyButtonPrice container
     itself; Concept replaces its children, not the node, so caching it is safe. */
  const buttonPriceEl = window.gsgSectionScope(wrapper).querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const deliveryRate   = parseFloat(wrapper.dataset.deliveryRate)   || 0;
  const residentialFee = parseFloat(wrapper.dataset.residentialFee) || 0;
  const liftgateFee    = parseFloat(wrapper.dataset.liftgateFee)    || 0;

  const productSku  = (wrapper.dataset.productSku  || '').trim();
  const variantSkus = (wrapper.dataset.variantSkus || '').split(',').map(s => s.trim()).filter(Boolean);

  function toVariantId(raw) {
    if (!raw) return null;
    const str = String(raw).trim();
    const match = str.match(/(\d+)\s*$/);
    return match ? parseInt(match[1], 10) : null;
  }

  const deliveryVariantId    = toVariantId(wrapper.dataset.deliveryVariantId);
  const residentialVariantId = toVariantId(wrapper.dataset.residentialVariantId);
  const liftgateVariantId    = toVariantId(wrapper.dataset.liftgateVariantId);

  let isDelivery    = null;
  let isResidential = null;
  let needsLiftgate = null;
  let activeVariantId = toVariantId(wrapper.dataset.initialVariantId) || null;
  const vendorName = wrapper.dataset.vendor || 'the manufacturer';
  /* RECEIVING CLASS (gsg.receiving_class, from the supplier quote sheet):
     parcel | ltl_liftgate_available | ltl_forklift_required |
     commercial_forklift_required | manual_quote. Empty = legacy flow.
     Kills the invalid-service bug: forklift-required items never sell
     liftgate; commercial-only items never sell residential. */
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* PRICING CUTOVER FLAG (shop.metafields.custom.katool_pricing_cutover):
     false = legacy baked-price model (pickup credit, discount redirect).
     true  = MAP model: preview = price + selected freight + chosen fees;
     pickup = price alone; no credits, no discount codes. The cutover
     runbook flips the flag in the same window as the price import. */
  const pricingCutover = (wrapper.dataset.pricingCutover || '').trim() === 'true';
  const baseShippingCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  let classBlocked = null; // warning reason currently blocking completion
  let isTerminal = false;  // forklift-required item + no forklift -> terminal freight
  const TERMINAL_METHOD = 'Freight to Local Terminal (you collect - closest terminal assigned after purchase)';

  const productForm = window.gsgProductForm(wrapper);

  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);

  if (!window.gsgClaimWidget(addToCartBtn, 'challenger_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  function renderStockBadge(status, missingSkus) {
    if (!stockBadge) return;
    stockBadge.className = 'gsg-stock-badge';
    switch (status) {
      case 'in':
        stockBadge.classList.add('gsg-stock--in');
        stockBadge.textContent = 'In Stock';
        break;
      case 'low':
        stockBadge.classList.add('gsg-stock--low');
        stockBadge.textContent = 'Limited Stock - Order Soon';
        break;
      case 'out':
        stockBadge.classList.add('gsg-stock--out');
        stockBadge.textContent = 'Backordered - Order Now to Reserve';
        stockBadge.title = vendorName + ' inventories refill fast. Order now to be first in line when new stock lands.';
        break;
      case 'partial':
        stockBadge.classList.add('gsg-stock--partial');
        stockBadge.textContent = 'Partially Backordered - Order Now to Reserve';
        break;
      default:
        stockBadge.style.display = 'none';
        return;
    }
    stockBadge.style.display = 'inline-flex';
  }

  function updateStockBadge(location) {
    if (!stockBadge) return;
    if (!gsgInventoryData) { stockBadge.style.display = 'none'; return; }
    // A variant present in the map but carrying NO data at all (no status, no
    // qty, no timestamp, no pool) has no inventory feed behind it - every brand
    // outside the Katool feed. Show nothing: an absent badge claims nothing
    // either way, which is the honest state. Since 2026-08-31 an unknown or
    // under-review status is treated the same way (no badge) rather than
    // raising a confirmation prompt.
    const rawInv = gsgInventoryData.variants && gsgInventoryData.variants[String(activeVariantId)];
    if (rawInv && !rawInv.status && rawInv.qty == null && !rawInv.updated && !rawInv.pool) {
      stockBadge.style.display = 'none';
      return;
    }
    const inv = gsgVariantInventory(activeVariantId);
    if (!inv || !inv.status || inv.status === 'manual_review' || inv.status === 'not_mapped') {
      // REMOVED 2026-08-31 (Jordan): the availability-confirmation badge is
      // gone for good. When status is unknown or under review we now show NO
      // badge at all - an absent badge claims nothing either way, which is the
      // honest state, and it no longer reads as a warning about this product.
      // Age is no longer considered: a variant is judged on its data, not on
      // how long ago the sync ran.
      stockBadge.style.display = 'none';
      return;
    }
    if (inv.discontinued) {
      stockBadge.className = 'gsg-stock-badge gsg-stock--out';
      stockBadge.textContent = 'Out of Stock';
      stockBadge.title = '';
      stockBadge.style.display = 'inline-flex';
      return;
    }
    let status = null;
    if (location) {
      const q = inv.pickup[location] || 0;
      status = q === 0 ? 'out' : (q <= KATOOL_LOW_STOCK ? 'low' : 'in');
    } else if (inv.status === 'out_of_stock') {
      status = 'out';
    } else if (inv.status === 'in_stock' || inv.status === 'pickup_unavailable') {
      status = (inv.qty !== null && inv.qty <= KATOOL_LOW_STOCK) ? 'low' : 'in';
    }
    if (!status) { stockBadge.style.display = 'none'; return; }
    renderStockBadge(status);
  }

function updateLocationStockOptions() {
  if (!locationSelect) return;
  // No inventory data on this page (template not yet migrated, e.g.
  // regularshipping): leave the legacy markup untouched, never gate pickup.
  if (!gsgInventoryData) return;
  const inv = gsgVariantInventory(activeVariantId);
  const list = gsgPickupList(inv);

  // REMOVED 2026-08-31 (Jordan): the availability-confirmation note that used
  // to appear above the flow is gone. NOTE: the separate .gsg-confirm-note used
  // further down for "your delivery or pickup choice is confirmed at checkout"
  // is a DIFFERENT message and stays.
  updatePickupSummary(inv && inv.discontinued ? [] : list);

  const placeholder = Array.from(locationSelect.options).find(function (o) { return !o.value; });
  locationSelect.innerHTML = '';
  if (placeholder) locationSelect.appendChild(placeholder);
  list.forEach(function (item) {
    const opt = document.createElement('option');
    opt.value = item.key;
    opt.textContent = item.reg.name + ' - ' + item.reg.address +
      (item.qty <= KATOOL_LOW_STOCK ? ' (Low Stock)' : '');
    locationSelect.appendChild(opt);
  });

  if (inv && inv.discontinued) {
    wrapper.querySelectorAll('.delivery-option-btn').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item is no longer available';
    });
    updateStockBadge(null);
    updatePickupSummary([]);
    return;
  }
  const pickupBtn = wrapper.querySelector('.delivery-option-btn[data-option="pickup"]');
  if (pickupBtn) {
    const available = list.length > 0;
    pickupBtn.disabled = !available;
    pickupBtn.title = available ? '' : 'Pickup is currently unavailable for this item';
    if (!available && isDelivery === false) {
      isDelivery = null;
      pickupBtn.classList.remove('selected');
      updateVisibility();
      checkCompletion();
    }
  }
}

  function checkCompletion() {
    let isComplete = false;
    if (isDelivery === true) {
      if (receivingClass === 'parcel') {
        isComplete = true;               // small parcel: no freight questions
      } else if (classBlocked) {
        isComplete = false;              // invalid receiving answer selected
      } else {
        isComplete = isResidential !== null && needsLiftgate !== null;
      }
    } else if (isDelivery === false) {
      isComplete = locationSelect && locationSelect.value !== '';
    }
    window.gsgSetCartButtonState(addToCartBtn, isComplete);
    if (completeMessage) completeMessage.style.display = isComplete ? 'flex' : 'none';
    return isComplete;
  }

  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (pricingCutover) {
      // MAP model: freight and fees are added at checkout; preview mirrors it
      if (isDelivery === true) {
        total = basePrice + baseShippingCharge;
        if (!isTerminal) {
          // terminal freight carries full freight but no fees
          if (isResidential === true) total += residentialFee;
          if (needsLiftgate === true) total += liftgateFee;
        }
      } else if (isDelivery === false) {
        total = basePrice;   // pickup = product price, nothing added
      }
    } else if (isDelivery === true) {
      if (isResidential === true) total += residentialFee;
      if (needsLiftgate === true) total += liftgateFee;
    } else if (isDelivery === false) {
      total = basePrice - deliveryRate;
    }
    /* Displayed price includes selected add-ons (Jordan 2026-08-31): one
       number that matches what Add to Cart will add. Whenever that number
       is not the bare variant price (fees or add-ons folded in), the
       compare-at is hidden via the composite flag so a raised price never
       renders above its own strikethrough. */
    const gsgAddons = window.gsgSelectedAddons(wrapper);
    const gsgShown = total + gsgAddons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(gsgShown), gsgShown !== basePrice);
    window.gsgRenderAddonNote(wrapper, gsgAddons);
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Non-cutover legacy pricing keeps the per-unit label - unproven. */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = total;
      if (pricingCutover) {
        gsgBtn = basePrice * gsgQ;
        if (isDelivery === true) {
          gsgBtn += baseShippingCharge * gsgQ;
          if (!isTerminal) {
            if (isResidential === true) gsgBtn += residentialFee;
            if (needsLiftgate === true) gsgBtn += liftgateFee;
          }
        }
      }
      /* Selected add-ons are real items in the widget's add - the button
         total must never understate the amount about to be added. */
      gsgBtn += gsgAddons.cents / 100;
      window.gsgWireBundleRefresh(wrapper, updatePrice);
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }

  function updateVisibility() {
    if (pickupDropdown) pickupDropdown.style.display = (isDelivery === false) ? 'block' : 'none';
    if (deliveryAddons) deliveryAddons.style.display = (isDelivery === true && receivingClass !== 'parcel') ? 'block' : 'none';
  }

  function showClassWarning(text) {
    classBlocked = text || null;
    let w = wrapper.querySelector('.gsg-class-warning');
    if (!w && deliveryAddons) {
      w = document.createElement('div');
      w.className = 'gsg-class-warning';
      deliveryAddons.appendChild(w);
    }
    if (w) {
      w.textContent = text || '';
      w.style.display = text ? 'block' : 'none';
    }
  }

  function showStepError(anchor, text) {
    if (!anchor) return;
    let e = anchor.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchor.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._gsgTimer);
    e._gsgTimer = setTimeout(function () { e.style.display = 'none'; }, 4500);
  }

  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function (e) { e.style.display = 'none'; });
    const atcErr = document.querySelector('.gsg-atc-error');
    if (atcErr) atcErr.style.display = 'none';
  }

  function showAtcError() {
    let err = document.querySelector('.gsg-atc-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', err);
    }
    err.textContent = isDelivery === null
      ? 'Please choose Delivery or Warehouse Pickup above first.'
      : 'Please answer the delivery questions above first.';
    err.style.display = 'block';
    clearTimeout(err._gsgTimer);
    err._gsgTimer = setTimeout(function () { err.style.display = 'none'; }, 4500);
  }

  function showTerminalNote(show) {
    let n = wrapper.querySelector('.gsg-terminal-note');
    if (!n && deliveryAddons) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-terminal-note';
      deliveryAddons.appendChild(n);
    }
    if (n) {
      n.textContent = 'A forklift is required to receive this item, so liftgate delivery is not available. No problem: we ship it to the freight terminal closest to your address and you pick it up there. The terminal loads your vehicle or trailer for you.';
      n.style.display = show ? 'block' : 'none';
    }
  }

  // MAP-model guidance: the checkout method choice is authoritative
  if (pricingCutover) {
    // Delivery button carries the per-product freight amount (varies by
    // product); "Standard" removed per Jordan
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      if (b.disabled) return;
      b.textContent = baseShippingCharge > 0
        ? 'Delivery - $' + baseShippingCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
        : 'Free Delivery';
    });
    const note = document.createElement('div');
    note.className = 'gsg-confirm-note';
    note.style.display = 'block';
    note.textContent = 'Your delivery or pickup choice is confirmed at checkout and applies to your whole order.';
    const title = wrapper.querySelector('.delivery-options-title');
    if (title && title.parentNode) title.parentNode.insertBefore(note, title.nextSibling);
  }

  // per-class UI prep
  if (forkliftRequired) {
    wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"][data-value="no"]').forEach(function (b) {
      b.textContent = 'No - I do not have a forklift';
    });
  }
  if (receivingClass === 'manual_quote') {
    wrapper.querySelectorAll('.delivery-option-btn[data-option="delivery"]').forEach(function (b) {
      b.disabled = true;
      b.title = 'This item requires a custom freight quote. Contact us before ordering.';
    });
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        // clicking the chosen method again steps back to no selection
        this.classList.remove('selected');
        isDelivery = null;
        isResidential = null;
        needsLiftgate = null;
        isTerminal = false;
        showTerminalNote(false);
        showClassWarning(null);
        clearStepErrors();
        addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
        if (locationSelect) locationSelect.value = '';
        updateVisibility();
        updatePrice();
        checkCompletion();
        updateStockBadge(null);
        return;
      }
      buttons.forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery    = this.dataset.option === 'delivery';
      isResidential = null;
      needsLiftgate = null;
      isTerminal = false;
      showTerminalNote(false);
      showClassWarning(null);
      clearStepErrors();
      addonButtons.forEach(function(ab) { ab.classList.remove('selected'); });
      if (locationSelect) locationSelect.value = '';
      updateVisibility();
      updatePrice();
      checkCompletion();
      if (isDelivery) {
        updateStockBadge(null);
      } else {
        updateLocationStockOptions();
        if (stockBadge) stockBadge.style.display = 'none';
      }
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      if (addon === 'liftgate' && isResidential === null) {
        // steps answer in order: no forklift answer before residential
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential address question first.');
        return;
      }
      if (this.classList.contains('selected')) {
        // clicking the chosen answer again un-answers it; anything
        // downstream resets too so the glow walks back with it
        clearStepErrors();
        this.classList.remove('selected');
        if (addon === 'residential') {
          isResidential = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="liftgate"]').forEach(function(b) { b.classList.remove('selected'); });
          needsLiftgate = null;
        }
        if (addon === 'liftgate' || addon === 'residential') {
          isTerminal = false;
          showTerminalNote(false);
          showClassWarning(null);
        }
        if (addon === 'liftgate') needsLiftgate = null;
        updatePrice();
        checkCompletion();
        return;
      }
      clearStepErrors();
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'residential') {
        if (value === 'yes' && receivingClass === 'commercial_forklift_required') {
          isResidential = null;
          showClassWarning('This item is delivered to commercial addresses with a forklift only. Residential delivery is not available. Contact us for options.');
        } else {
          isResidential = value === 'yes';
          if (classBlocked && classBlocked.indexOf('commercial addresses') >= 0) showClassWarning(null);
        }
      } else if (addon === 'liftgate') {
        if (value === 'no' && forkliftRequired) {
          // No forklift on a forklift-required item: terminal freight
          // instead of a dead end. Full freight, no fees at checkout.
          needsLiftgate = false;
          isTerminal = true;
          showClassWarning(null);
          showTerminalNote(true);
        } else {
          needsLiftgate = value === 'no';
          isTerminal = false;
          showTerminalNote(false);
          if (classBlocked && classBlocked.indexOf('forklift is required') >= 0) showClassWarning(null);
        }
      }
      updatePrice();
      checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function() {
      checkCompletion();
      updateStockBadge(this.value);
    });
  }

  updateLocationStockOptions();

  /* RELEASE 1: this used to listen for 'variant:changed', an event nothing in
     the theme ever dispatches (Concept's 'variant:change' does not bubble past
     the form). Subscribed to Concept's pubsub instead - the channel Concept
     actually publishes valid variant changes on. */
  window.gsgOnVariantChange(function(payload) {
    const variant = payload && payload.data && payload.data.variant;
    if (variant && variant.id) {
      activeVariantId = toVariantId(variant.id);
      updateLocationStockOptions();
      updateStockBadge(isDelivery === false && locationSelect ? locationSelect.value : null);
      if (isDelivery === false) updateLocationStockOptions();
      /* Concept just restored native price markup for the new variant;
         re-apply the configured total on top of the fresh base price. */
      updatePrice();
    }
  });

  /* No form-input fallback listener here: theme.js updateVariantInputs
     dispatches synthetic 'change' on the form's id inputs AND then publishes
     variantChange - listening to both ran every variant update twice. The
     pubsub subscription above is the single variant channel. */

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!productForm) {
        alert('Error: Could not find product form. Please refresh the page.');
        return;
      }

      if (!checkCompletion()) {
        showAtcError();
        return;
      }

      const mainVariantId = toVariantId(window.gsgSelectedVariantId(productForm));

      if (!mainVariantId) {
        alert('Error: Could not find product variant.');
        return;
      }

      const quantityInput = document.querySelector('input[name="quantity"]') ||
                            document.querySelector('.quantity-input input') ||
                            document.querySelector('.quantity__input');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [];
      // Human-readable properties for staff/order display, PLUS
      // machine-readable _gsg_* properties (underscore-prefixed = hidden
      // from customer display) - the signal channel for Calcurates
      // conditions (Option B property-driven rates).
      // Visible property mirrors the EXACT checkout method name so the
      // order summary tells the customer which shipping line to select
      let shippingTypeLabel = isDelivery ? 'Delivery' : 'Pickup';
      if (pricingCutover && isDelivery === true && isTerminal) {
        shippingTypeLabel = TERMINAL_METHOD;
      } else if (pricingCutover && isDelivery === true) {
        shippingTypeLabel = isResidential
          ? (needsLiftgate ? 'Freight Delivery - Residential + Liftgate Service'
                           : 'Freight Delivery - Residential (forklift on site)')
          : (needsLiftgate ? 'Freight Delivery - Commercial + Liftgate Service'
                           : 'Freight Delivery - Commercial (forklift or loading dock)');
      } else if (pricingCutover && isDelivery === false && locationSelect && locationSelect.value) {
        const regE = gsgRegistryEntry(locationSelect.value);
        shippingTypeLabel = 'Warehouse Pickup - ' + (regE ? regE.name : locationSelect.value);
      }
      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
        properties: {
          'Shipping Type': shippingTypeLabel,
          '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'
        }
      };

      if (isDelivery) {
        if (isTerminal) {
          // terminal freight: no fees, customer collects at the terminal
          mainItem.properties['Pickup Location'] = 'Nearest freight terminal';
          mainItem.properties['_gsg_terminal'] = 'yes';
        } else {
          if (isResidential) mainItem.properties['Residential Fee'] = 'Yes';
          if (needsLiftgate) mainItem.properties['Liftgate Service'] = 'Yes';
        }
        mainItem.properties['_gsg_residential'] = isResidential ? 'yes' : 'no';
        mainItem.properties['_gsg_liftgate'] = needsLiftgate ? 'yes' : 'no';
        if (receivingClass) mainItem.properties['_gsg_receiving_class'] = receivingClass;
      }
      if (!isDelivery && locationSelect && locationSelect.value) {
        const regEntry = gsgRegistryEntry(locationSelect.value);
        mainItem.properties['Pickup Location'] = regEntry
          ? regEntry.name + ' [' + locationSelect.value + ']'
          : locationSelect.value;
        mainItem.properties['_gsg_pickup_warehouse'] = locationSelect.value;
        const invNow = gsgVariantInventory(mainVariantId);
        const availableHere = invNow ? (invNow.pickup[locationSelect.value] || 0) : 0;
        if (availableHere > 0 && quantity > availableHere) {
          alert('Not enough stock at this warehouse for that quantity. Please reduce the quantity or choose delivery.');
          return;
        }
      }

      items.push(mainItem);

      if (isDelivery) {
        if (deliveryVariantId)                          items.push({ id: deliveryVariantId,    quantity: quantity });
        if (isResidential && residentialVariantId)      items.push({ id: residentialVariantId, quantity: 1 });
        if (needsLiftgate  && liftgateVariantId)        items.push({ id: liftgateVariantId,    quantity: 1 });
      }

      /* RELEASE 1: selected Popular Add-ons ride along as real cart items -
         previously ticked add-ons were silently dropped by this custom add. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });

      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) { throw new Error(data.description || 'Cart add failed'); });
        }
        return response.json();
      })
      .then(() => {
        // Checkout lock signal: the SupaEasy delivery function reads this
        // cart attribute and hides every checkout method whose title does
        // not match. Only written when the label IS an exact method name;
        // unknown labels fail open (function hides nothing).
        if (pricingCutover && /^(Freight Delivery - |Warehouse Pickup - |Freight to Local Terminal)/.test(shippingTypeLabel)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'gsg_selected_method': shippingTypeLabel } })
          }).catch(function() {}).then(function() {});
        }
      })
      .then(() => {
        if (!pricingCutover && !isDelivery && deliveryRate > 0) {
          // LEGACY ONLY: the pickup-credit discount dies at cutover
          const discountCode = 'PICKUP-CREDIT-' + Math.round(deliveryRate);
          window.location.href = '/discount/' + discountCode + '?redirect=/cart';
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));

          const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartIcon) cartIcon.click();
          else window.location.href = '/cart';
        }
      })
      .catch(function(error) {
        if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding;
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + error.message);
      });
    }, true);

    // The locked button has pointer-events none, so real clicks fall
    // through to the parent. Catch those and explain what is missing.
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right &&
          e.clientY >= r.top && e.clientY <= r.bottom) {
        showAtcError();
      }
    });
  }

  updateVisibility();
  updatePrice();
  checkCompletion();
  updateStockBadge(null);
});


/* BRANCH triumph_v1 - Triumph: forklift Q, NAT fees, regional surcharges (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Config comes from the
   shop brand_shipping_config metafield via #gsg-brand-config; new brands
   with the same question shapes are a registry entry, not new code. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="triumph_v1"]');
  if (!wrapper) return;
  const cfgEl = document.getElementById('gsg-brand-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const baseCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  const productSku = (wrapper.dataset.productSku || '').trim().toUpperCase();
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  const isParcel = receivingClass === 'parcel';  // gsgNatParcel: parts ship free ground, no LTL questions
  /* LIFTGATE CAPABILITY (brand-generic, opt-in via registry `liftgate: true`).
     Gate on receiving_class, NEVER on gsg.liftgate_ok. liftgate_ok is
     shipping-method / mixed-cart compatibility and is deliberately 'yes' on
     parcel items too, so it would wrongly ask a parcel buyer about a liftgate.
     Only an LTL item that can physically take a liftgate is asked. */
  const liftgateCapable = receivingClass === 'ltl_liftgate_available' && !!cfg.liftgate;
  /* A brand with no surcharge areas (Rotary) must not be shown a one-button
     area question it has to answer to proceed. Skip the step and pre-answer it. */
  const hasAreas = (cfg.areas || []).length > 0;
  const defaultArea = hasAreas ? null : 'none';
  const quoteSkus = ((cfg.quote_states || {}).skus || []).map(function(x){ return x.toUpperCase(); });
  const needsQuoteQuestion = quoteSkus.indexOf(productSku) >= 0;

  const productForm = window.gsgProductForm(wrapper);
  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'triumph_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  /* RELEASE 1: no cached price node - see gsgWritePrice. Button container is
     stable across Concept's child-swapping variant updates. */
  const buttonPriceEl = window.gsgSectionScope(wrapper).querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  // ---- build markup (class contract: delivery-option-btn / addon-btn /
  // delivery-addon-question / .selected -> glow cascade + lock apply)
  const body = wrapper.querySelector('.gsg-nat-body');
  const chargeLabel = isParcel ? 'Free Shipping'
    : (baseCharge > 0
    ? 'Delivery - $' + baseCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
    : 'Free Delivery');
  let html = '';
  html += '<div class="delivery-options-buttons">' +
    '<button type="button" class="delivery-option-btn" data-option="delivery">' + chargeLabel + '</button>' +
    ((cfg.pickups || []).length
      ? '<button type="button" class="delivery-option-btn" data-option="pickup">Warehouse Pickup</button>'
      : '') + '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  // Framing: on a zero-fee brand the questions are fulfilment planning, not upsells.
  if (cfg.questions_note) {
    html += '<div class="gsg-questions-note">' + cfg.questions_note + '</div>';
  }
  html += '<div class="delivery-addon-question" data-step="1">' +
    '<label>Is this a residential address, or a location with limited access for a large truck?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="yes">Yes' +
      ((cfg.fees.res_la || 0) > 0 ? ' (+$' + cfg.fees.res_la + ')' : '') + '</button>' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="no">No - Commercial with easy access</button>' +
    '</div></div>';
  if (hasAreas) {
    html += '<div class="delivery-addon-question" data-step="2">' +
      '<label>' + (cfg.area_question || 'Is your delivery address in any of these areas?') + '</label>' +
      '<div class="addon-buttons gsg-nat-areas">' +
      '<button type="button" class="addon-btn" data-addon="area" data-value="none">No, none of these</button>';
    (cfg.areas || []).forEach(function(a) {
      html += '<button type="button" class="addon-btn" data-addon="area" data-value="' + a.key + '">' + a.label + '</button>';
    });
    html += '</div></div>';
  }
  if (liftgateCapable) {
    const lgFee = (cfg.fees || {}).liftgate || 0;
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift or loading dock to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="no">Yes - no liftgate needed</button>' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="yes">No - add liftgate service' +
        (lgFee > 0 ? ' (+$' + lgFee + ')' : '') + '</button>' +
      '</div></div>';
  }
  if (forkliftRequired) {
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift, tractor, or other heavy machinery to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - I cannot unload it</button>' +
      '</div></div>';
  }
  if (needsQuoteQuestion) {
    html += '<div class="delivery-addon-question" data-step="4">' +
      '<label>' + ((cfg.quote_states || {}).question || 'Is your delivery address in a quote-required state?') + '</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="no">No</button>' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="yes">Yes</button>' +
      '</div></div>';
  }
  html += '</div>';
  html += '<div class="pickup-location-dropdown" style="display:none;">' +
    '<label for="gsg-nat-pickup">Select Pickup Location:</label>' +
    '<select id="gsg-nat-pickup"><option value="" selected disabled>PLEASE SELECT A PICKUP LOCATION</option>';
  (cfg.pickups || []).forEach(function(pk) {
    html += '<option value="' + pk.key + '">' + pk.label.replace('Warehouse Pickup - ', '') + (pk.hours ? ' (' + pk.hours + ')' : '') + '</option>';
  });
  html += '</select>';
  if (cfg.pickup_note) {
    html += '<div class="pickup-info-box"><div class="pickup-info-title">Pickup Information</div>' +
      '<div class="pickup-info-list" style="font-size:13px;">' + cfg.pickup_note + '</div></div>';
  }
  html += '</div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const locationSelect = wrapper.querySelector('#gsg-nat-pickup');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');

  let isDelivery = null, resLA = null, area = defaultArea, unloadOk = null, qstate = null, liftgate = null;

  function noteBox(cls) {
    let n = wrapper.querySelector('.' + cls);
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning ' + cls;
      deliveryAddons.appendChild(n);
    }
    return n;
  }
  function showBlockNote(text) {
    const n = noteBox('gsg-nat-block');
    n.textContent = text || '';
    n.style.display = text ? 'block' : 'none';
  }
  function showStepError(anchorEl, text) {
    if (!anchorEl) return;
    let e = anchorEl.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchorEl.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._t);
    e._t = setTimeout(function(){ e.style.display = 'none'; }, 4500);
  }
  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function(e){ e.style.display = 'none'; });
    const g = document.querySelector('.gsg-atc-error'); if (g) g.style.display = 'none';
  }

  function blockedReason() {
    if (unloadOk === false) return 'unload';
    if (qstate === true) return 'quote_state';
    if (area === 'island') return 'island';
    return null;
  }
  function areaCfg() {
    return (cfg.areas || []).find(function(a){ return a.key === area; }) || null;
  }
  function selectedLabel() {
    if (isDelivery === false) {
      const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
      return pk ? pk.label : null;
    }
    if (isParcel) return 'Free Shipping';
    if (liftgateCapable && liftgate === true) {
      return resLA ? cfg.labels.res_lg : cfg.labels.com_lg;
    }
    let label = resLA ? cfg.labels.res_la : cfg.labels.com;
    const a = areaCfg();
    if (a && a.suffix_key && cfg.labels[a.suffix_key]) label += cfg.labels[a.suffix_key];
    return label;
  }
  function checkCompletion() {
    let complete = false;
    if (isDelivery === true) {
      complete = isParcel ? true
               : resLA !== null && area !== null && !blockedReason() &&
                 (!forkliftRequired || unloadOk === true) &&
                 (!liftgateCapable || liftgate !== null) &&
                 (!needsQuoteQuestion || qstate === false);
    } else if (isDelivery === false) {
      complete = !!(locationSelect && locationSelect.value);
    }
    window.gsgSetCartButtonState(addToCartBtn, complete);
    if (completeMessage) completeMessage.style.display = complete ? 'flex' : 'none';
    return complete;
  }
  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (isDelivery === true) {
      total = basePrice + baseCharge;
      if (resLA === true) total += (cfg.fees.res_la || 0);
      if (liftgateCapable && liftgate === true) total += ((cfg.fees || {}).liftgate || 0);
      const a = areaCfg();
      if (a && a.fee_type === 'flat') total += (a.fee || 0);
      if (a && a.fee_type === 'per_piece') total += (a.fee_first || 0);
    }
    /* Displayed price includes selected add-ons - see katool note. */
    const gsgAddons = window.gsgSelectedAddons(wrapper);
    const gsgShown = total + gsgAddons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(gsgShown), gsgShown !== basePrice);
    window.gsgRenderAddonNote(wrapper, gsgAddons);
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Registry semantics: res_la flat/order; area flat -> fee once;
         area per_piece -> fee_first + fee_additional x (qty-1). */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = basePrice * gsgQ;
      if (isDelivery === true) {
        gsgBtn += baseCharge * gsgQ;
        if (resLA === true) gsgBtn += (cfg.fees.res_la || 0);
        if (liftgateCapable && liftgate === true) gsgBtn += ((cfg.fees || {}).liftgate || 0);
        var gsgA = areaCfg();
        if (gsgA && gsgA.fee_type === 'flat') gsgBtn += (gsgA.fee || 0);
        if (gsgA && gsgA.fee_type === 'per_piece') gsgBtn += (gsgA.fee_first || 0) + (gsgA.fee_additional || 0) * (gsgQ - 1);
      }
      /* Selected add-ons are real items in the widget's add - the button
         total must never understate the amount about to be added. */
      gsgBtn += gsgAddons.cents / 100;
      window.gsgWireBundleRefresh(wrapper, updatePrice);
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }
  /* RELEASE 1: recompute the configured total when Concept publishes a valid
     variant change (it just restored native price markup for the new variant). */
  window.gsgOnVariantChange(function () {
    updatePrice();
  });
  function updateVisibility() {
    deliveryAddons.style.display = (isDelivery === true && !isParcel) ? 'block' : 'none';
    pickupDropdown.style.display = isDelivery === false ? 'block' : 'none';
  }
  function resetAnswers() {
    resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
    addonButtons.forEach(function(b){ b.classList.remove('selected'); });
    showBlockNote(null);
    if (locationSelect) locationSelect.value = '';
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      clearStepErrors();
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        isDelivery = null; resetAnswers();
        updateVisibility(); updatePrice(); checkCompletion();
        return;
      }
      buttons.forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery = this.dataset.option === 'delivery';
      resetAnswers();
      updateVisibility(); updatePrice(); checkCompletion();
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      // order enforcement
      if (addon === 'area' && resLA === null) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential or limited access question first.');
        return;
      }
      if ((addon === 'unload' || addon === 'qstate' || addon === 'liftgate') && (resLA === null || area === null)) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the questions above first.');
        return;
      }
      clearStepErrors();
      if (this.classList.contains('selected')) {
        // deselect walks backwards; downstream resets
        this.classList.remove('selected');
        if (addon === 'res_la') { resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="area"],.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'area') { area = null; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'unload') unloadOk = null;
        if (addon === 'qstate') qstate = null;
        if (addon === 'liftgate') liftgate = null;
        showBlockNote(null);
        updatePrice(); checkCompletion();
        return;
      }
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'res_la') resLA = value === 'yes';
      if (addon === 'area') area = value;
      if (addon === 'unload') unloadOk = value === 'yes';
      if (addon === 'qstate') qstate = value === 'yes';
      if (addon === 'liftgate') liftgate = value === 'yes';
      const reason = blockedReason();
      if (reason === 'unload') {
        showBlockNote(cfg.unloading_note || 'Heavy unloading equipment is required for delivery. Choose warehouse pickup or contact us before ordering.');
      } else if (reason === 'island' || reason === 'quote_state') {
        showBlockNote('This delivery address needs a custom freight quote before ordering. Contact us and we will confirm your exact shipping cost, or choose warehouse pickup.');
      } else {
        showBlockNote(null);
      }
      updatePrice(); checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function(){ checkCompletion(); });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (!productForm) { alert('Error: Could not find product form. Please refresh the page.'); return; }
      if (!checkCompletion()) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = isDelivery === null
          ? 'Please choose Delivery or Warehouse Pickup above first.'
          : (blockedReason() ? 'This selection needs pickup or a quote. See the note above, or contact us.'
                             : 'Please answer the delivery questions above first.');
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const label = selectedLabel();
      const props = {'Shipping Type': label, '_gsg_fee_schedule': wrapper.dataset.feeSchedule,
                     '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'};
      if (isDelivery) {
        if (!isParcel) {
          props['_gsg_res_la'] = resLA ? 'yes' : 'no';
          props['_gsg_area'] = area;
          if (liftgateCapable) props['_gsg_liftgate'] = liftgate ? 'yes' : 'no';
        }
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      } else {
        const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
        props['Pickup Location'] = pk ? pk.label.replace('Warehouse Pickup - ', '') : locationSelect.value;
        props['_gsg_pickup_warehouse'] = locationSelect.value;
      }
      const items = [{id: variantId, quantity: quantity, properties: props}];
      /* RELEASE 1: selected Popular Add-ons ride along as real cart items. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        if (label && (/^(Freight Delivery - |Warehouse Pickup - )/.test(label) || label === 'Free Shipping')) {
          return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {'gsg_selected_method': label}})}).catch(function(){}).then(function(){});
        }
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding; alert('Error adding to cart: ' + error.message); });
    }, true);

    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }

  updateVisibility(); updatePrice(); checkCompletion();
});

/* BRANCH rotary_v1 - Rotary: free everything (revocable here), questions never price (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Config comes from the
   shop brand_shipping_config metafield via #gsg-brand-config; new brands
   with the same question shapes are a registry entry, not new code. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="rotary_v1"]');
  if (!wrapper) return;
  const cfgEl = document.getElementById('gsg-brand-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;
  const baseCharge = parseFloat(wrapper.dataset.baseShippingCharge) || 0;
  const receivingClass = (wrapper.dataset.receivingClass || '').trim();
  const productSku = (wrapper.dataset.productSku || '').trim().toUpperCase();
  const forkliftRequired = receivingClass === 'ltl_forklift_required' ||
                           receivingClass === 'commercial_forklift_required';
  const isParcel = receivingClass === 'parcel';  // gsgNatParcel: parts ship free ground, no LTL questions
  /* LIFTGATE CAPABILITY (brand-generic, opt-in via registry `liftgate: true`).
     Gate on receiving_class, NEVER on gsg.liftgate_ok. liftgate_ok is
     shipping-method / mixed-cart compatibility and is deliberately 'yes' on
     parcel items too, so it would wrongly ask a parcel buyer about a liftgate.
     Only an LTL item that can physically take a liftgate is asked. */
  const liftgateCapable = receivingClass === 'ltl_liftgate_available' && !!cfg.liftgate;
  /* A brand with no surcharge areas (Rotary) must not be shown a one-button
     area question it has to answer to proceed. Skip the step and pre-answer it. */
  const hasAreas = (cfg.areas || []).length > 0;
  const defaultArea = hasAreas ? null : 'none';
  const quoteSkus = ((cfg.quote_states || {}).skus || []).map(function(x){ return x.toUpperCase(); });
  const needsQuoteQuestion = quoteSkus.indexOf(productSku) >= 0;

  const productForm = window.gsgProductForm(wrapper);
  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'rotary_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  /* RELEASE 1: no cached price node - see gsgWritePrice. Button container is
     stable across Concept's child-swapping variant updates. */
  const buttonPriceEl = window.gsgSectionScope(wrapper).querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                        document.querySelector('.product-form__submit .price');

  // ---- build markup (class contract: delivery-option-btn / addon-btn /
  // delivery-addon-question / .selected -> glow cascade + lock apply)
  const body = wrapper.querySelector('.gsg-nat-body');
  const chargeLabel = isParcel ? 'Free Shipping'
    : (baseCharge > 0
    ? 'Delivery - $' + baseCharge.toLocaleString('en-US', {maximumFractionDigits: 0})
    : 'Free Delivery');
  let html = '';
  html += '<div class="delivery-options-buttons">' +
    '<button type="button" class="delivery-option-btn" data-option="delivery">' + chargeLabel + '</button>' +
    ((cfg.pickups || []).length
      ? '<button type="button" class="delivery-option-btn" data-option="pickup">Warehouse Pickup</button>'
      : '') + '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  // Framing: on a zero-fee brand the questions are fulfilment planning, not upsells.
  if (cfg.questions_note) {
    html += '<div class="gsg-questions-note">' + cfg.questions_note + '</div>';
  }
  html += '<div class="delivery-addon-question" data-step="1">' +
    '<label>Is this a residential address, or a location with limited access for a large truck?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="yes">Yes' +
      ((cfg.fees.res_la || 0) > 0 ? ' (+$' + cfg.fees.res_la + ')' : '') + '</button>' +
    '<button type="button" class="addon-btn" data-addon="res_la" data-value="no">No - Commercial with easy access</button>' +
    '</div></div>';
  if (hasAreas) {
    html += '<div class="delivery-addon-question" data-step="2">' +
      '<label>' + (cfg.area_question || 'Is your delivery address in any of these areas?') + '</label>' +
      '<div class="addon-buttons gsg-nat-areas">' +
      '<button type="button" class="addon-btn" data-addon="area" data-value="none">No, none of these</button>';
    (cfg.areas || []).forEach(function(a) {
      html += '<button type="button" class="addon-btn" data-addon="area" data-value="' + a.key + '">' + a.label + '</button>';
    });
    html += '</div></div>';
  }
  if (liftgateCapable) {
    const lgFee = (cfg.fees || {}).liftgate || 0;
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift or loading dock to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="no">Yes - no liftgate needed</button>' +
      '<button type="button" class="addon-btn" data-addon="liftgate" data-value="yes">No - add liftgate service' +
        (lgFee > 0 ? ' (+$' + lgFee + ')' : '') + '</button>' +
      '</div></div>';
  }
  if (forkliftRequired) {
    html += '<div class="delivery-addon-question" data-step="3">' +
      '<label>Do you have a forklift, tractor, or other heavy machinery to unload this from the truck?</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
      '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - I cannot unload it</button>' +
      '</div></div>';
  }
  if (needsQuoteQuestion) {
    html += '<div class="delivery-addon-question" data-step="4">' +
      '<label>' + ((cfg.quote_states || {}).question || 'Is your delivery address in a quote-required state?') + '</label>' +
      '<div class="addon-buttons">' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="no">No</button>' +
      '<button type="button" class="addon-btn" data-addon="qstate" data-value="yes">Yes</button>' +
      '</div></div>';
  }
  html += '</div>';
  html += '<div class="pickup-location-dropdown" style="display:none;">' +
    '<label for="gsg-nat-pickup">Select Pickup Location:</label>' +
    '<select id="gsg-nat-pickup"><option value="" selected disabled>PLEASE SELECT A PICKUP LOCATION</option>';
  (cfg.pickups || []).forEach(function(pk) {
    html += '<option value="' + pk.key + '">' + pk.label.replace('Warehouse Pickup - ', '') + (pk.hours ? ' (' + pk.hours + ')' : '') + '</option>';
  });
  html += '</select>';
  if (cfg.pickup_note) {
    html += '<div class="pickup-info-box"><div class="pickup-info-title">Pickup Information</div>' +
      '<div class="pickup-info-list" style="font-size:13px;">' + cfg.pickup_note + '</div></div>';
  }
  html += '</div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  const buttons = wrapper.querySelectorAll('.delivery-option-btn');
  const addonButtons = wrapper.querySelectorAll('.addon-btn');
  const deliveryAddons = wrapper.querySelector('.delivery-addons');
  const pickupDropdown = wrapper.querySelector('.pickup-location-dropdown');
  const locationSelect = wrapper.querySelector('#gsg-nat-pickup');
  const completeMessage = wrapper.querySelector('.delivery-complete-message');

  let isDelivery = null, resLA = null, area = defaultArea, unloadOk = null, qstate = null, liftgate = null;

  function noteBox(cls) {
    let n = wrapper.querySelector('.' + cls);
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning ' + cls;
      deliveryAddons.appendChild(n);
    }
    return n;
  }
  function showBlockNote(text) {
    const n = noteBox('gsg-nat-block');
    n.textContent = text || '';
    n.style.display = text ? 'block' : 'none';
  }
  function showStepError(anchorEl, text) {
    if (!anchorEl) return;
    let e = anchorEl.querySelector(':scope > .gsg-step-error');
    if (!e) {
      e = document.createElement('div');
      e.className = 'gsg-step-error';
      anchorEl.appendChild(e);
    }
    e.textContent = text;
    e.style.display = 'block';
    clearTimeout(e._t);
    e._t = setTimeout(function(){ e.style.display = 'none'; }, 4500);
  }
  function clearStepErrors() {
    wrapper.querySelectorAll('.gsg-step-error').forEach(function(e){ e.style.display = 'none'; });
    const g = document.querySelector('.gsg-atc-error'); if (g) g.style.display = 'none';
  }

  function blockedReason() {
    if (unloadOk === false) return 'unload';
    if (qstate === true) return 'quote_state';
    if (area === 'island') return 'island';
    return null;
  }
  function areaCfg() {
    return (cfg.areas || []).find(function(a){ return a.key === area; }) || null;
  }
  function selectedLabel() {
    if (isDelivery === false) {
      const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
      return pk ? pk.label : null;
    }
    if (isParcel) return 'Free Shipping';
    if (liftgateCapable && liftgate === true) {
      return resLA ? cfg.labels.res_lg : cfg.labels.com_lg;
    }
    let label = resLA ? cfg.labels.res_la : cfg.labels.com;
    const a = areaCfg();
    if (a && a.suffix_key && cfg.labels[a.suffix_key]) label += cfg.labels[a.suffix_key];
    return label;
  }
  function checkCompletion() {
    let complete = false;
    if (isDelivery === true) {
      complete = isParcel ? true
               : resLA !== null && area !== null && !blockedReason() &&
                 (!forkliftRequired || unloadOk === true) &&
                 (!liftgateCapable || liftgate !== null) &&
                 (!needsQuoteQuestion || qstate === false);
    } else if (isDelivery === false) {
      complete = !!(locationSelect && locationSelect.value);
    }
    window.gsgSetCartButtonState(addToCartBtn, complete);
    if (completeMessage) completeMessage.style.display = complete ? 'flex' : 'none';
    return complete;
  }
  function updatePrice() {
    const basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    let total = basePrice;
    if (isDelivery === true) {
      total = basePrice + baseCharge;
      if (resLA === true) total += (cfg.fees.res_la || 0);
      if (liftgateCapable && liftgate === true) total += ((cfg.fees || {}).liftgate || 0);
      const a = areaCfg();
      if (a && a.fee_type === 'flat') total += (a.fee || 0);
      if (a && a.fee_type === 'per_piece') total += (a.fee_first || 0);
    }
    /* Displayed price includes selected add-ons - see katool note. */
    const gsgAddons = window.gsgSelectedAddons(wrapper);
    const gsgShown = total + gsgAddons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(gsgShown), gsgShown !== basePrice);
    window.gsgRenderAddonNote(wrapper, gsgAddons);
    if (buttonPriceEl) {
      /* quantity-aware button total, component-wise (see header comment).
         Registry semantics: res_la flat/order; area flat -> fee once;
         area per_piece -> fee_first + fee_additional x (qty-1). */
      var gsgQ = gsgQtyFor(wrapper);
      var gsgBtn = basePrice * gsgQ;
      if (isDelivery === true) {
        gsgBtn += baseCharge * gsgQ;
        if (resLA === true) gsgBtn += (cfg.fees.res_la || 0);
        if (liftgateCapable && liftgate === true) gsgBtn += ((cfg.fees || {}).liftgate || 0);
        var gsgA = areaCfg();
        if (gsgA && gsgA.fee_type === 'flat') gsgBtn += (gsgA.fee || 0);
        if (gsgA && gsgA.fee_type === 'per_piece') gsgBtn += (gsgA.fee_first || 0) + (gsgA.fee_additional || 0) * (gsgQ - 1);
      }
      /* Selected add-ons are real items in the widget's add - the button
         total must never understate the amount about to be added. */
      gsgBtn += gsgAddons.cents / 100;
      window.gsgWireBundleRefresh(wrapper, updatePrice);
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(gsgBtn);
      gsgWireQtyRefresh(wrapper, updatePrice);
    }
  }
  /* RELEASE 1: recompute the configured total when Concept publishes a valid
     variant change (it just restored native price markup for the new variant). */
  window.gsgOnVariantChange(function () {
    updatePrice();
  });
  function updateVisibility() {
    deliveryAddons.style.display = (isDelivery === true && !isParcel) ? 'block' : 'none';
    pickupDropdown.style.display = isDelivery === false ? 'block' : 'none';
  }
  function resetAnswers() {
    resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
    addonButtons.forEach(function(b){ b.classList.remove('selected'); });
    showBlockNote(null);
    if (locationSelect) locationSelect.value = '';
  }

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      clearStepErrors();
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        isDelivery = null; resetAnswers();
        updateVisibility(); updatePrice(); checkCompletion();
        return;
      }
      buttons.forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      isDelivery = this.dataset.option === 'delivery';
      resetAnswers();
      updateVisibility(); updatePrice(); checkCompletion();
    });
  });

  addonButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addon = this.dataset.addon;
      const value = this.dataset.value;
      // order enforcement
      if (addon === 'area' && resLA === null) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the residential or limited access question first.');
        return;
      }
      if ((addon === 'unload' || addon === 'qstate' || addon === 'liftgate') && (resLA === null || area === null)) {
        showStepError(this.closest('.delivery-addon-question'),
          'Please answer the questions above first.');
        return;
      }
      clearStepErrors();
      if (this.classList.contains('selected')) {
        // deselect walks backwards; downstream resets
        this.classList.remove('selected');
        if (addon === 'res_la') { resLA = null; area = defaultArea; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="area"],.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'area') { area = null; unloadOk = null; qstate = null; liftgate = null;
          wrapper.querySelectorAll('.addon-btn[data-addon="unload"],.addon-btn[data-addon="qstate"],.addon-btn[data-addon="liftgate"]').forEach(function(b){ b.classList.remove('selected'); }); }
        if (addon === 'unload') unloadOk = null;
        if (addon === 'qstate') qstate = null;
        if (addon === 'liftgate') liftgate = null;
        showBlockNote(null);
        updatePrice(); checkCompletion();
        return;
      }
      wrapper.querySelectorAll('.addon-btn[data-addon="' + addon + '"]').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      if (addon === 'res_la') resLA = value === 'yes';
      if (addon === 'area') area = value;
      if (addon === 'unload') unloadOk = value === 'yes';
      if (addon === 'qstate') qstate = value === 'yes';
      if (addon === 'liftgate') liftgate = value === 'yes';
      const reason = blockedReason();
      if (reason === 'unload') {
        showBlockNote(cfg.unloading_note || 'Heavy unloading equipment is required for delivery. Choose warehouse pickup or contact us before ordering.');
      } else if (reason === 'island' || reason === 'quote_state') {
        showBlockNote('This delivery address needs a custom freight quote before ordering. Contact us and we will confirm your exact shipping cost, or choose warehouse pickup.');
      } else {
        showBlockNote(null);
      }
      updatePrice(); checkCompletion();
    });
  });

  if (locationSelect) {
    locationSelect.addEventListener('change', function(){ checkCompletion(); });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (!productForm) { alert('Error: Could not find product form. Please refresh the page.'); return; }
      if (!checkCompletion()) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = isDelivery === null
          ? 'Please choose Delivery or Warehouse Pickup above first.'
          : (blockedReason() ? 'This selection needs pickup or a quote. See the note above, or contact us.'
                             : 'Please answer the delivery questions above first.');
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const label = selectedLabel();
      const props = {'Shipping Type': label, '_gsg_fee_schedule': wrapper.dataset.feeSchedule,
                     '_gsg_fulfillment_mode': isDelivery ? 'delivery' : 'pickup'};
      if (isDelivery) {
        if (!isParcel) {
          props['_gsg_res_la'] = resLA ? 'yes' : 'no';
          props['_gsg_area'] = area;
          if (liftgateCapable) props['_gsg_liftgate'] = liftgate ? 'yes' : 'no';
        }
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      } else {
        const pk = (cfg.pickups || []).find(function(p){ return p.key === locationSelect.value; });
        props['Pickup Location'] = pk ? pk.label.replace('Warehouse Pickup - ', '') : locationSelect.value;
        props['_gsg_pickup_warehouse'] = locationSelect.value;
      }
      const items = [{id: variantId, quantity: quantity, properties: props}];
      /* RELEASE 1: selected Popular Add-ons ride along as real cart items. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        if (label && (/^(Freight Delivery - |Warehouse Pickup - )/.test(label) || label === 'Free Shipping')) {
          return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({attributes: {'gsg_selected_method': label}})}).catch(function(){}).then(function(){});
        }
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding; alert('Error adding to cart: ' + error.message); });
    }, true);

    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }

  updateVisibility(); updatePrice(); checkCompletion();
});

/* BRANCH forward_v1 - Forward: free everything, confirm-only (Widget Tree V1 2026-08-27). OWN BRANCH -
   edit freely, no other brand shares this code. Renders only
   on forklift-class products (template-gated): a single unloading
   confirmation. Everything else on the brand has no widget at all. */
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.delivery-options-wrapper[data-flow="forward_v1"]');
  if (!wrapper) return;
  const productForm = window.gsgProductForm(wrapper);
  const addToCartBtn = window.gsgSectionScope(wrapper).querySelector('.product-form__submit') ||
                       document.querySelector('.product-form__submit') ||
                       (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'forward_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  const body = wrapper.querySelector('.gsg-free-body');
  body.innerHTML =
    '<div class="delivery-addons" style="display:block;">' +
    '<div class="delivery-addon-question" data-step="1">' +
    '<label>This item ships free by freight truck. Do you have a forklift or loading dock to unload it?</label>' +
    '<div class="addon-buttons">' +
    '<button type="button" class="addon-btn" data-addon="unload" data-value="yes">Yes - I can unload it</button>' +
    '<button type="button" class="addon-btn" data-addon="unload" data-value="no">No - contact me about delivery options</button>' +
    '</div></div></div>' +
    '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';

  const completeMessage = wrapper.querySelector('.delivery-complete-message');
  let unloadOk = null;
  function note(show) {
    let n = wrapper.querySelector('.gsg-free-note');
    if (!n) {
      n = document.createElement('div');
      n.className = 'gsg-class-warning gsg-free-note';
      body.appendChild(n);
    }
    n.textContent = 'No problem. Order by phone or chat and we will arrange delivery options that work for your location before anything ships. Call ' +
      '855-498-2147 or use the chat bubble.';
    n.style.display = show ? 'block' : 'none';
  }
  function check() {
    const ok = unloadOk === true;
    window.gsgSetCartButtonState(addToCartBtn, ok);
    if (completeMessage) completeMessage.style.display = ok ? 'flex' : 'none';
  }
  wrapper.querySelectorAll('.addon-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('selected')) {
        this.classList.remove('selected');
        unloadOk = null; note(false); check();
        return;
      }
      wrapper.querySelectorAll('.addon-btn').forEach(function(b){ b.classList.remove('selected'); });
      this.classList.add('selected');
      unloadOk = this.dataset.value === 'yes';
      note(!unloadOk);
      check();
    });
  });
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (unloadOk !== true) {
        let err = document.querySelector('.gsg-atc-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'gsg-step-error gsg-atc-error';
          addToCartBtn.insertAdjacentElement('afterend', err);
        }
        err.textContent = 'Please confirm unloading above first.';
        err.style.display = 'block';
        clearTimeout(err._t);
        err._t = setTimeout(function(){ err.style.display = 'none'; }, 4500);
        return;
      }
      const variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { alert('Error: Could not find product variant.'); return; }
      const qtyInput = document.querySelector('input[name="quantity"]') ||
                       document.querySelector('.quantity-input input') || document.querySelector('.quantity__input');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const items = [{id: variantId, quantity: quantity,
          properties: {'Shipping Type': 'Free Shipping', '_gsg_fulfillment_mode': 'delivery',
                       '_gsg_unload_confirmed': 'yes'}}];
      /* RELEASE 1: selected Popular Add-ons ride along as real cart items. */
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn && addToCartBtn.dataset.gsgAdding === '1') return;
      if (addToCartBtn) addToCartBtn.dataset.gsgAdding = '1';
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
      .then(function(r){ if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Cart add failed'); }); return r.json(); })
      .then(function() {
        return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({attributes: {'gsg_selected_method': 'Free Shipping'}})}).catch(function(){}).then(function(){});
      })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        const cartIcon = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
        if (cartIcon) cartIcon.click(); else window.location.href = '/cart';
      })
      .catch(function(error) { if (addToCartBtn) delete addToCartBtn.dataset.gsgAdding; alert('Error adding to cart: ' + error.message); });
    }, true);
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      const r = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
        addToCartBtn.click();
      }
    });
  }
});

/* ============ BRANCH aff_v1 - American Forge & Foundry ============
   Grown 2026-09-10 from the foundation. OWN BRANCH: nothing here was copied
   from another brand, and nothing here is shared with one.
   Base freight is calculated per cart by the GSG freight engine at checkout,
   so this branch never shows or computes a freight price. The visible price
   and the Add to Cart total add the delivery fees chosen so far (merchandise
   x qty, fees flat per order, per the foundation header).
   Markup follows the house widget grammar (the same classes Katool and
   Triumph render): a delivery-option-btn pair, a delivery-addons panel hidden
   until a mode is picked, one gsg-questions-note, and delivery-addon-question
   blocks with a plain question and short answers carrying inline fees. The
   data-option / data-addon attributes exist only to opt into the shared CSS
   glow cascade in assets/delivery-options.css; this branch's logic reads
   data-aff alone.
   Fee amounts come from the registry entry `fees`, keyed by method, and must
   equal the FPO of the matching Calcurates 11053 row. The step fees shown are
   derived from those method totals (residence = residential_forklift;
   liftgate = the rest), so the steps always add up to the row.
   It writes the EXACT checkout method title as the 'Shipping Type' line
   property and as the gsg_selected_method cart attribute (the SupaEasy lock
   keeps only the method whose title matches), plus the _gsg_* line
   properties the engine reads.
   A shopper can only add to cart on a method listed in the registry entry
   `methods`. Any other answer is routed to terminal pickup or to a person,
   so an unlisted delivery can never be undercharged.
   Adding or removing a method, or changing a fee = registry edit. No code change. */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.delivery-options-wrapper[data-flow="aff_v1"]');
  if (!wrapper) return;
  var cfg = {};
  try {
    var cfgEl = document.getElementById('gsg-aff-config');
    cfg = (cfgEl && JSON.parse(cfgEl.textContent)) || {};
  } catch (e) { cfg = {}; }
  var M = cfg.methods || {};
  var F = cfg.fees || {};
  var phone = cfg.phone || '855-498-2147';
  var receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* Liftgate capability is a physical fact of the item, so it comes from
     receiving_class only, never from gsg.liftgate_ok (method compatibility). */
  var liftgateCapable = receivingClass === 'ltl_liftgate_available';
  /* Commercial-only items never sell residential (receiving-class doctrine):
     a residential answer routes to a person. */
  var commercialOnly = receivingClass === 'commercial_forklift_required';
  var residentialOffered = !commercialOnly &&
    !!(M.residential_forklift || (liftgateCapable && M.residential_liftgate));
  var commercialLiftgate = liftgateCapable && !!M.commercial_liftgate;
  var residentialLiftgate = liftgateCapable && !!M.residential_liftgate;

  var scope = window.gsgSectionScope(wrapper);
  var productForm = window.gsgProductForm(wrapper);
  var addToCartBtn = scope.querySelector('.product-form__submit') ||
                     document.querySelector('.product-form__submit') ||
                     (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'aff_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  var body = wrapper.querySelector('.gsg-aff-body');
  if (!body) return;

  function fee(key) {
    var n = Number(F[key]);
    return n > 0 ? n : 0;
  }
  /* Step fees, derived from the per-method totals. */
  var residenceFee = fee('residential_forklift');
  var liftgateFeeBusiness = fee('commercial_liftgate');
  var liftgateFeeResidence = Math.max(0, fee('residential_liftgate') - residenceFee);

  /* Concept replaces the children of #BuyButtonPrice, not the node, so caching
     the container is safe; the visible price is written via gsgWritePrice. */
  var buttonPriceEl = scope.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit .price');
  var basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;

  function money(n) { return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function withFee(text, n) { return n ? text + ' (+' + money(n) + ')' : text; }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
    });
  }
  function btn(cls, key, value, text, attrs) {
    return '<button type="button" class="' + cls + '" data-aff="' + key + '" data-value="' + value + '"' +
      (attrs || '') + '>' + esc(text) + '</button>';
  }
  function question(step, label, buttons) {
    return '<div class="delivery-addon-question" data-aff-step="' + step + '" style="display:none;">' +
      '<label>' + esc(label) + '</label><div class="addon-buttons">' + buttons + '</div></div>';
  }

  var html = '<div class="delivery-options-buttons">' +
    btn('delivery-option-btn', 'mode', 'delivery', 'Freight Delivery', ' data-option="delivery"') +
    (M.terminal ? btn('delivery-option-btn', 'mode', 'terminal', 'Freight Terminal Pickup', ' data-option="terminal"') : '') +
    '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  html += '<div class="gsg-questions-note gsg-aff-delivery-note" style="display:none;">' +
    'Ships by freight truck. Freight is calculated at checkout. Any delivery fee you choose below is included in the price shown above.</div>';
  html += '<div class="gsg-questions-note gsg-aff-terminal-note" style="display:none;margin-bottom:0;">' +
    'Your order ships to the freight terminal closest to you, and you collect it there. ' +
    'We confirm the terminal after purchase. No delivery fees apply.</div>';
  html += question('site', 'Is this a residential address, or a location with limited access for a large truck?',
    btn('addon-btn', 'site', 'residence', residentialOffered ? withFee('Yes', residenceFee) : 'Yes', ' data-addon="residential"') +
    btn('addon-btn', 'site', 'business', 'No - Commercial', ' data-addon="residential"'));
  /* One unload question; its wording follows the address answer. */
  html += question('unload', '',
    btn('addon-btn', 'unload', 'yes', 'Yes - No liftgate needed', ' data-addon="liftgate"') +
    btn('addon-btn', 'unload', 'no', 'No', ' data-addon="liftgate"'));
  html += '</div>';
  html += '<div class="gsg-class-warning gsg-aff-contact" style="display:none;"></div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  var addonsPanel = body.querySelector('.delivery-addons');
  var deliveryNote = body.querySelector('.gsg-aff-delivery-note');
  var terminalNote = body.querySelector('.gsg-aff-terminal-note');
  var qSite = body.querySelector('[data-aff-step="site"]');
  var qUnload = body.querySelector('[data-aff-step="unload"]');
  var unloadLabel = qUnload.querySelector('label');
  var unloadNo = qUnload.querySelector('[data-value="no"]');
  var contact = body.querySelector('.gsg-aff-contact');
  var done = body.querySelector('.delivery-complete-message');

  var mode = null;    // 'delivery' | 'terminal'
  var site = null;    // 'business' | 'residence'
  var unload = null;  // true = forklift or dock on site, false = liftgate / none

  /* undefined = still answering; null = no offerable method, route to a
     person; object = the one checkout method this line ships by. */
  function resolve() {
    if (mode === 'terminal') {
      return M.terminal ? {key: 'terminal', label: M.terminal, terminal: true, residential: false, liftgate: false} : null;
    }
    if (mode !== 'delivery' || site === null) return undefined;
    if (site === 'residence' && !residentialOffered) return null;
    if (unload === null) return undefined;
    if (site === 'business') {
      if (unload) return M.commercial_dock ? {key: 'commercial_dock', label: M.commercial_dock, residential: false, liftgate: false} : null;
      return commercialLiftgate
        ? {key: 'commercial_liftgate', label: M.commercial_liftgate, residential: false, liftgate: true} : null;
    }
    if (unload) return M.residential_forklift ? {key: 'residential_forklift', label: M.residential_forklift, residential: true, liftgate: false} : null;
    return residentialLiftgate
      ? {key: 'residential_liftgate', label: M.residential_liftgate, residential: true, liftgate: true} : null;
  }

  /* The fees the answers so far add. Terminal pickup adds none. */
  function feesSoFar() {
    if (mode !== 'delivery') return 0;
    var total = 0;
    if (site === 'residence' && residentialOffered) total += residenceFee;
    if (unload === false) {
      total += site === 'residence' ? (residentialLiftgate ? liftgateFeeResidence : 0)
                                    : (commercialLiftgate ? liftgateFeeBusiness : 0);
    }
    return total;
  }

  /* Visible price and button total = item + fees chosen so far (+ add-ons).
     Merchandise is x qty; the fees are flat per order. A route to a person
     adds nothing. Base freight is unknown until checkout and is never shown. */
  function updatePrice() {
    var r = resolve();
    var f = r === null ? 0 : feesSoFar();
    var basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    var addons = window.gsgSelectedAddons(wrapper);
    var shown = basePrice + f + addons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(shown), shown !== basePrice);
    window.gsgRenderAddonNote(wrapper, addons);
    if (buttonPriceEl) {
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' +
        gsgMoney(basePrice * gsgQtyFor(wrapper) + f + addons.cents / 100);
    }
  }
  window.gsgWireBundleRefresh(wrapper, updatePrice);
  gsgWireQtyRefresh(wrapper, updatePrice);
  /* Concept restores native price markup on a variant change; re-apply. */
  window.gsgOnVariantChange(function () { updatePrice(); });

  function show(el, on, display) { if (el) el.style.display = on ? (display || 'block') : 'none'; }

  function setUnloadCopy() {
    var res = site === 'residence';
    unloadLabel.textContent = res ? 'Do you have a forklift at the address to unload it?'
                                  : 'Do you have a forklift or loading dock to unload it?';
    var lgOk = res ? residentialLiftgate : commercialLiftgate;
    unloadNo.textContent = lgOk ? withFee('No - Add liftgate', res ? liftgateFeeResidence : liftgateFeeBusiness)
                                : 'No - I cannot unload it';
  }

  function render() {
    show(addonsPanel, mode !== null);
    show(deliveryNote, mode === 'delivery');
    show(terminalNote, mode === 'terminal');
    show(qSite, mode === 'delivery');
    setUnloadCopy();
    show(qUnload, mode === 'delivery' && site !== null && (site === 'business' || residentialOffered));
    var r = resolve();
    if (r === null) {
      contact.textContent = 'We arrange this delivery individually. Call ' + phone +
        ' or use the chat bubble and we will confirm delivery options and freight before you order.' +
        (M.terminal ? ' You can also choose freight terminal pickup.' : '');
    }
    show(contact, r === null);
    show(done, !!r, 'flex');
    window.gsgSetCartButtonState(addToCartBtn, !!r);
    updatePrice();
  }

  function mark(key, value) {
    body.querySelectorAll('[data-aff="' + key + '"]').forEach(function (b) {
      b.classList.toggle('selected', value !== null && b.dataset.value === value);
    });
  }

  var atcError = null;
  function hideAtcError() { if (atcError) atcError.style.display = 'none'; }
  function showAtcError(message) {
    if (!addToCartBtn) return;
    if (!atcError) {
      atcError = document.createElement('div');
      atcError.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', atcError);
    }
    atcError.textContent = message;
    atcError.style.display = 'block';
    clearTimeout(atcError._t);
    atcError._t = setTimeout(function () { atcError.style.display = 'none'; }, 4500);
  }

  body.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button[data-aff]') : null;
    if (!b || !body.contains(b)) return;
    var key = b.dataset.aff, value = b.dataset.value, again = b.classList.contains('selected');
    if (key === 'mode') { mode = again ? null : value; site = null; unload = null; }
    else if (key === 'site') { site = again ? null : value; unload = null; }
    else if (key === 'unload') { unload = again ? null : value === 'yes'; }
    mark('mode', mode);
    mark('site', site);
    mark('unload', unload === null ? null : (unload ? 'yes' : 'no'));
    hideAtcError();
    render();
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var r = resolve();
      if (!r) {
        showAtcError(r === null
          ? 'This delivery is arranged by phone. See the note above.' + (M.terminal ? ' Or choose freight terminal pickup.' : '')
          : (mode === null
              ? (M.terminal ? 'Please choose Freight Delivery or Freight Terminal Pickup above first.'
                            : 'Please choose Freight Delivery above first.')
              : 'Please answer the delivery questions above first.'));
        return;
      }
      if (!productForm) { showAtcError('Something went wrong. Please refresh the page.'); return; }
      var variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { showAtcError('Please choose an option for this product first.'); return; }
      var qtyInput = scope.querySelector('input[name="quantity"]') ||
                     document.querySelector('input[name="quantity"]') ||
                     document.querySelector('.quantity__input');
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var props = {'Shipping Type': r.label, '_gsg_fulfillment_mode': 'delivery'};
      if (r.terminal) {
        props['Pickup Location'] = 'Nearest freight terminal';
        props['_gsg_terminal'] = 'yes';
      } else {
        if (r.residential) props['Residential Fee'] = 'Yes';
        if (r.liftgate) props['Liftgate Service'] = 'Yes';
      }
      props['_gsg_residential'] = r.residential ? 'yes' : 'no';
      props['_gsg_liftgate'] = r.liftgate ? 'yes' : 'no';
      if (receivingClass) props['_gsg_receiving_class'] = receivingClass;

      var items = [{id: variantId, quantity: quantity, properties: props}];
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn.dataset.gsgAdding === '1') return;
      addToCartBtn.dataset.gsgAdding = '1';

      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function () {
          /* Lock signal: only an exact checkout method title is ever written. */
          if (/^(Freight Delivery - |Freight to Local Terminal)/.test(r.label)) {
            return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({attributes: {'gsg_selected_method': r.label}})}).catch(function () {});
          }
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var cartLink = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartLink) cartLink.click(); else window.location.href = '/cart';
        })
        .catch(function (err) {
          delete addToCartBtn.dataset.gsgAdding;
          showAtcError('Could not add to cart: ' + err.message);
        });
    }, true);

    /* A locked button ignores pointer events, so a real click lands on the
       parent. Catch it and run the handler above, which says what is missing. */
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      var rect = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
        addToCartBtn.click();
      }
    });
  }

  render();
});
/* ============ BRANCH stratus_v1 - Stratus Auto Equipment ============
   Grown 2026-10-09 from the foundation. OWN BRANCH: nothing here was copied
   from another brand, and nothing here is shared with one.
   Jordan, 2026-10-09: free shipping, and Stratus's widget is its own. It
   follows Stratus's own delivery terms: base freight is free; a regional
   surcharge applies in the states the registry lists; the delivery location
   is commercial with a forklift, residential with a forklift, limited access
   (farm, dealership, rural), or a freight terminal; every delivery needs a
   forklift or loading dock (no liftgate), and the shopper confirms they will
   inspect the delivery and note any damage with the driver. Warehouse pickup
   is offered when the registry lists one.
   Fees come from the registry entry `fees` and must equal the FPO of the
   matching Calcurates 11053 stratus rows (res_la per order, regional per
   order, both together on the regional residential row).
   It writes the EXACT checkout method title as the 'Shipping Type' line
   property and as the gsg_selected_method cart attribute (the SupaEasy lock
   keeps only the method whose title matches), plus the _gsg_* line
   properties the cart reads (_gsg_res_la, _gsg_area).
   A shopper can only add to cart on a method listed in the registry entry
   `methods`. Any other answer routes to a person, so an unlisted delivery
   is never undercharged.
   Changing a fee, a state list or a method = registry edit. No code change. */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.delivery-options-wrapper[data-flow="stratus_v1"]');
  if (!wrapper) return;
  var cfg = {};
  try {
    var cfgEl = document.getElementById('gsg-stratus-config');
    cfg = (cfgEl && JSON.parse(cfgEl.textContent)) || {};
  } catch (e) { cfg = {}; }
  var M = cfg.methods || {};
  var F = cfg.fees || {};
  var phone = cfg.phone || '855-498-2147';
  var area = (cfg.areas || []).filter(function (a) { return a && a.key === 'regional'; })[0] || null;
  var pickup = (cfg.pickups || [])[0] || null;
  var receivingClass = (wrapper.dataset.receivingClass || '').trim();
  /* Commercial-only items never sell residential or limited access. */
  var commercialOnly = receivingClass === 'commercial_forklift_required';

  var scope = window.gsgSectionScope(wrapper);
  var productForm = window.gsgProductForm(wrapper);
  var addToCartBtn = scope.querySelector('.product-form__submit') ||
                     document.querySelector('.product-form__submit') ||
                     (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'stratus_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  var body = wrapper.querySelector('.gsg-stratus-body');
  if (!body) return;

  function fee(key) {
    var n = Number(F[key]);
    return n > 0 ? n : 0;
  }
  var resLaFee = fee('res_la');
  var regionalFee = area ? (Number(area.fee) || 0) : 0;

  var buttonPriceEl = scope.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit .price');
  var basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;

  function money(n) { return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function withFee(text, n) { return n ? text + ' (+' + money(n) + ')' : text; }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
    });
  }
  function btn(cls, key, value, text, attrs) {
    return '<button type="button" class="' + cls + '" data-str="' + key + '" data-value="' + value + '"' +
      (attrs || '') + '>' + esc(text) + '</button>';
  }
  function question(step, label, buttons) {
    return '<div class="delivery-addon-question" data-str-step="' + step + '" style="display:none;">' +
      '<label>' + esc(label) + '</label><div class="addon-buttons">' + buttons + '</div></div>';
  }

  var html = '<div class="delivery-options-buttons">' +
    btn('delivery-option-btn', 'mode', 'delivery', 'Free Freight Delivery', ' data-option="delivery"') +
    (pickup && M.pickup ? btn('delivery-option-btn', 'mode', 'pickup', 'Warehouse Pickup', ' data-option="pickup"') : '') +
    '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  html += '<div class="gsg-questions-note gsg-str-delivery-note" style="display:none;">' +
    'Ships free by freight truck. A forklift or loading dock is needed to unload it. ' +
    'Any delivery fee you choose below is included in the price shown above.</div>';
  html += '<div class="gsg-questions-note gsg-str-pickup-note" style="display:none;margin-bottom:0;">' +
    (pickup ? esc(pickup.note || ('You collect your order at our warehouse in ' + (pickup.city || '') + '. We contact you when it is ready.')) : '') +
    '</div>';
  if (area) {
    html += question('region', area.question || ('Is the delivery address in ' + (area.label || '') + '?'),
      btn('addon-btn', 'region', 'yes', withFee('Yes', regionalFee), ' data-addon="residential"') +
      btn('addon-btn', 'region', 'no', 'No', ' data-addon="residential"'));
  }
  html += question('location', 'Where are we delivering it?',
    btn('addon-btn', 'location', 'commercial', 'Commercial, with forklift or dock', ' data-addon="liftgate"') +
    (commercialOnly ? '' :
      btn('addon-btn', 'location', 'residential', withFee('Residential, with forklift', resLaFee), ' data-addon="liftgate"') +
      btn('addon-btn', 'location', 'limited', withFee('Farm, dealership or rural', resLaFee), ' data-addon="liftgate"')) +
    (M.terminal ? btn('addon-btn', 'location', 'terminal', 'Freight terminal pickup', ' data-addon="liftgate"') : '') +
    btn('addon-btn', 'location', 'none', 'No forklift', ' data-addon="liftgate"'));
  html += question('inspect', cfg.inspection_ack ||
      'When it arrives, I will check the shipment for damage or missing parts, tell the driver about any problem, and record it with photos and on the delivery receipt.',
    btn('addon-btn', 'inspect', 'yes', 'Yes, I understand', ' data-addon="residential"'));
  html += '</div>';
  html += '<div class="gsg-class-warning gsg-str-contact" style="display:none;"></div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  /* Up to five delivery-location answers: a two-column grid, so none run off the column. */
  var locButtons = body.querySelector('[data-str-step="location"] .addon-buttons');
  if (locButtons) locButtons.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:8px;';
  var addonsPanel = body.querySelector('.delivery-addons');
  var deliveryNote = body.querySelector('.gsg-str-delivery-note');
  var pickupNote = body.querySelector('.gsg-str-pickup-note');
  var qRegion = body.querySelector('[data-str-step="region"]');
  var qLocation = body.querySelector('[data-str-step="location"]');
  var qInspect = body.querySelector('[data-str-step="inspect"]');
  var terminalBtn = body.querySelector('[data-str="location"][data-value="terminal"]');
  var contact = body.querySelector('.gsg-str-contact');
  var done = body.querySelector('.delivery-complete-message');

  var mode = null;       // 'delivery' | 'pickup'
  var region = area ? null : false;   // true = surcharge states
  var location = null;   // 'commercial' | 'residential' | 'limited' | 'terminal' | 'none'
  var inspected = false;

  /* Terminal pickup is offered outside the surcharge states only: the cart
     treats a terminal shipment as fee-free, so a surcharge on it would show
     one total in the cart and another at checkout. */
  function terminalOffered() { return !!M.terminal && region === false; }

  /* undefined = still answering; null = no offerable method, route to a
     person; object = the one checkout method this line ships by. */
  function resolve() {
    if (mode === 'pickup') {
      return pickup && M.pickup ? {label: M.pickup, pickup: true} : null;
    }
    if (mode !== 'delivery' || region === null || location === null) return undefined;
    if (location === 'none') return null;
    if (location === 'terminal') {
      if (!terminalOffered()) return null;
      return inspected ? {label: M.terminal, terminal: true} : undefined;
    }
    var resLa = location === 'residential' || location === 'limited';
    if (resLa && commercialOnly) return null;
    var key = (resLa ? 'res_la' : 'commercial') + (region ? '_regional' : '');
    if (!M[key]) return null;
    if (!inspected) return undefined;
    return {label: M[key], resLa: resLa, regional: !!region, location: location};
  }

  function feesSoFar() {
    if (mode !== 'delivery') return 0;
    var total = region ? regionalFee : 0;
    if ((location === 'residential' || location === 'limited') && !commercialOnly) total += resLaFee;
    return total;
  }

  function updatePrice() {
    var r = resolve();
    var f = r === null ? 0 : feesSoFar();
    var basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    var addons = window.gsgSelectedAddons(wrapper);
    var shown = basePrice + f + addons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(shown), shown !== basePrice);
    window.gsgRenderAddonNote(wrapper, addons);
    if (buttonPriceEl) {
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' +
        gsgMoney(basePrice * gsgQtyFor(wrapper) + f + addons.cents / 100);
    }
  }
  window.gsgWireBundleRefresh(wrapper, updatePrice);
  gsgWireQtyRefresh(wrapper, updatePrice);
  window.gsgOnVariantChange(function () { updatePrice(); });

  function show(el, on, display) { if (el) el.style.display = on ? (display || 'block') : 'none'; }

  function render() {
    var delivering = mode === 'delivery';
    show(addonsPanel, mode !== null);
    show(deliveryNote, delivering);
    show(pickupNote, mode === 'pickup');
    show(qRegion, delivering);
    show(terminalBtn, terminalOffered(), 'inline-block');
    if (location === 'terminal' && !terminalOffered()) location = null;
    show(qLocation, delivering && region !== null);
    show(qInspect, delivering && region !== null && location !== null && location !== 'none');
    var r = resolve();
    if (r === null) {
      contact.textContent = location === 'none'
        ? 'Stratus lifts need a forklift or loading dock to unload. Call ' + phone +
          ' or use the chat bubble and we will help you arrange delivery before you order.'
        : 'We arrange this delivery individually. Call ' + phone +
          ' or use the chat bubble and we will confirm delivery options before you order.';
    }
    show(contact, r === null);
    show(done, !!r, 'flex');
    window.gsgSetCartButtonState(addToCartBtn, !!r);
    updatePrice();
  }

  function mark(key, value) {
    body.querySelectorAll('[data-str="' + key + '"]').forEach(function (b) {
      b.classList.toggle('selected', value !== null && b.dataset.value === value);
    });
  }

  var atcError = null;
  function hideAtcError() { if (atcError) atcError.style.display = 'none'; }
  function showAtcError(message) {
    if (!addToCartBtn) return;
    if (!atcError) {
      atcError = document.createElement('div');
      atcError.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', atcError);
    }
    atcError.textContent = message;
    atcError.style.display = 'block';
    clearTimeout(atcError._t);
    atcError._t = setTimeout(function () { atcError.style.display = 'none'; }, 4500);
  }

  body.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button[data-str]') : null;
    if (!b || !body.contains(b)) return;
    var key = b.dataset.str, value = b.dataset.value, again = b.classList.contains('selected');
    if (key === 'mode') {
      mode = again ? null : value; region = area ? null : false; location = null; inspected = false;
    } else if (key === 'region') {
      region = again ? null : value === 'yes'; location = null; inspected = false;
    } else if (key === 'location') {
      location = again ? null : value; inspected = false;
    } else if (key === 'inspect') {
      inspected = !again;
    }
    mark('mode', mode);
    mark('region', region === null ? null : (region ? 'yes' : 'no'));
    mark('location', location);
    mark('inspect', inspected ? 'yes' : null);
    hideAtcError();
    render();
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var r = resolve();
      if (!r) {
        showAtcError(r === null
          ? 'This delivery is arranged by phone. See the note above.'
          : (mode === null ? 'Please choose a delivery method above first.'
                           : 'Please answer the delivery questions above first.'));
        return;
      }
      if (!productForm) { showAtcError('Something went wrong. Please refresh the page.'); return; }
      var variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { showAtcError('Please choose an option for this product first.'); return; }
      var qtyInput = scope.querySelector('input[name="quantity"]') ||
                     document.querySelector('input[name="quantity"]') ||
                     document.querySelector('.quantity__input');
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var props = {'Shipping Type': r.label};
      if (r.pickup) {
        props['Pickup Location'] = pickup.city || r.label;
        props['_gsg_fulfillment_mode'] = 'pickup';
        props['_gsg_pickup_warehouse'] = pickup.key || 'stratus';
      } else {
        props['_gsg_fulfillment_mode'] = 'delivery';
        if (r.terminal) {
          props['Pickup Location'] = 'Nearest freight terminal';
          props['_gsg_terminal'] = 'yes';
        }
        /* The cart reads _gsg_res_la for the residential / limited access fee
           and _gsg_area for the regional surcharge (registry areas). */
        props['_gsg_residential'] = 'no';
        props['_gsg_liftgate'] = 'no';
        if (r.resLa) {
          props['_gsg_res_la'] = 'yes';
          props['Delivery Location'] = r.location === 'limited' ? 'Limited access' : 'Residential';
        }
        props['_gsg_area'] = r.regional ? 'regional' : 'none';
        if (r.regional) props['Regional Surcharge'] = 'Yes';
        props['_gsg_inspection_ack'] = 'yes';
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      }

      var items = [{id: variantId, quantity: quantity, properties: props}];
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn.dataset.gsgAdding === '1') return;
      addToCartBtn.dataset.gsgAdding = '1';

      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function () {
          /* Lock signal: only an exact checkout method title is ever written. */
          if (/^(Freight Delivery - |Freight to Local Terminal|Warehouse Pickup - )/.test(r.label)) {
            return fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({attributes: {'gsg_selected_method': r.label}})}).catch(function () {});
          }
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var cartLink = document.querySelector('[data-cart-toggle], .cart-icon, .header__cart, a[href="/cart"]');
          if (cartLink) cartLink.click(); else window.location.href = '/cart';
        })
        .catch(function (err) {
          delete addToCartBtn.dataset.gsgAdding;
          showAtcError('Could not add to cart: ' + err.message);
        });
    }, true);

    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      var rect = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
        addToCartBtn.click();
      }
    });
  }

  render();
});
/* ============ BRANCH daytona_v1 - Daytona Automotive Equipment ============
   Grown 2026-10-20 from the foundation. OWN BRANCH: nothing here was copied
   from another brand, and nothing here is shared with one.
   Jordan, 2026-10-19/20: Daytona freight ships from Ontario and is quoted per
   order, and the shopper chooses how: "Get Freight Quote" (a contact form;
   Add to Cart stays locked and Jordan sends one invoice) or "Order Now"
   (checkout now, freight quoted and invoiced after). Daytona offers
   no liftgate: the truck is unloaded with a forklift or at a loading dock, or
   the shopper collects at the carrier's freight terminal.
   The quote form is the native Shopify contact form rendered by this branch's
   chooser block (outside the product form); answers ride along as hidden
   contact fields. Its inputs carry no name="id", "quantity" or "bundles" and
   no form= attribute, so the foundation's form readers never see them.
   Order now writes the exact checkout title from the registry entry
   `methods.order_now` as 'Shipping Type', plus Daytona-only _gsg_dt_*
   properties Jordan reads on the order. It does NOT write the
   gsg_selected_method cart attribute: Daytona's delivery profile carries one
   rate, so no lock is needed, and a Daytona line must never override another
   brand's delivery choice in a mixed cart.
   Pickup appears only when the registry entry lists a pickup point.
   Flat freight (2026-10-22, Jordan: test on LTPF12 at $200): when the registry
   entry names `methods.flat` and the product carries gsg.base_shipping_charge,
   there is no quote path. Freight Delivery goes straight to the unloading
   questions, the note states the flat amount added at checkout, and the line
   is written with that exact checkout title and _gsg_dt_freight = flat. */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.delivery-options-wrapper[data-flow="daytona_v1"]');
  if (!wrapper) return;
  var cfg = {};
  try {
    var cfgEl = document.getElementById('gsg-daytona-config');
    cfg = (cfgEl && JSON.parse(cfgEl.textContent)) || {};
  } catch (e) { cfg = {}; }
  var M = cfg.methods || {};
  var phone = cfg.phone || '855-498-2147';
  var pickup = (cfg.pickups || [])[0] || null;
  var receivingClass = (wrapper.dataset.receivingClass || '').trim();
  var flatFee = parseFloat(wrapper.dataset.flatFreight) || 0;
  var flat = !!(M.flat && flatFee > 0);

  var scope = window.gsgSectionScope(wrapper);
  var productForm = window.gsgProductForm(wrapper);
  var addToCartBtn = scope.querySelector('.product-form__submit') ||
                     document.querySelector('.product-form__submit') ||
                     (productForm ? productForm.querySelector('button[type="submit"]') : null);
  if (!window.gsgClaimWidget(addToCartBtn, 'daytona_v1')) return;
  window.gsgSetCartButtonState(addToCartBtn, false);

  var body = wrapper.querySelector('.gsg-daytona-body');
  var quoteWrap = wrapper.querySelector('.gsg-dt-quote-wrap');
  var quoteForm = quoteWrap ? quoteWrap.querySelector('form') : null;
  if (!body) return;

  var buttonPriceEl = scope.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit [id^="BuyButtonPrice"]') ||
                      document.querySelector('.product-form__submit .price');
  var basePriceFallback = parseFloat(wrapper.dataset.basePrice) || 0;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c];
    });
  }
  function choice(cls, key, value, text, attrs) {
    return '<button type="button" class="' + cls + '" data-dt="' + key + '" data-value="' + value + '"' +
      (attrs || '') + '>' + esc(text) + '</button>';
  }
  function ask(step, label, buttons) {
    return '<div class="delivery-addon-question" data-dt-step="' + step + '" style="display:none;">' +
      '<label>' + esc(label) + '</label><div class="addon-buttons">' + buttons + '</div></div>';
  }
  function yesNo(key, yes, no, glow) {
    var g = glow ? ' data-addon="' + glow + '"' : '';
    return choice('addon-btn', key, 'yes', yes || 'Yes', g) + choice('addon-btn', key, 'no', no || 'No', g);
  }

  var html = '<div class="gsg-questions-note gsg-dt-sent" style="display:none;">' +
    'Thank you. Your freight quote request was sent, and we will contact you with your quote.</div>';
  html += '<div class="delivery-options-buttons">' +
    choice('delivery-option-btn', 'mode', 'delivery', 'Freight Delivery', ' data-option="delivery"') +
    (pickup && M.pickup ? choice('delivery-option-btn', 'mode', 'pickup', 'Warehouse Pickup', ' data-option="pickup"') : '') +
    '</div>';
  html += '<div class="delivery-addons" style="display:none;">';
  html += '<div class="gsg-questions-note gsg-dt-delivery-note" style="display:none;">' +
    (flat ? 'Ships by freight truck. Freight delivery is ' + esc(gsgMoney(flatFee)) + ', added at checkout.'
          : 'Ships by freight truck. Freight is not included in the price shown. We quote it for your delivery address.') +
    '</div>';
  html += '<div class="gsg-questions-note gsg-dt-pickup-note" style="display:none;margin-bottom:0;">' +
    (pickup ? esc(pickup.note || ('You collect your order at the warehouse in ' + (pickup.city || '') + '. We contact you when it is ready.')) : '') +
    '</div>';
  html += '<div class="delivery-options-buttons gsg-dt-path" style="display:none;">' +
    choice('delivery-option-btn', 'path', 'quote', 'Get Freight Quote', ' data-option="quote"') +
    (M.order_now ? choice('delivery-option-btn', 'path', 'order', 'Order Now', ' data-option="order"') : '') +
    '</div>';
  html += '<div class="gsg-questions-note gsg-dt-quote-note" style="display:none;">' +
    'Tell us about the delivery site and we will email your freight quote. You then get one invoice for the equipment and freight.</div>';
  html += '<div class="gsg-questions-note gsg-dt-order-note" style="display:none;">' +
    'Check out now for the equipment. After you order, we quote freight for your address and send it as a separate invoice.</div>';
  html += ask('site', 'Is the delivery address residential or commercial?',
    choice('addon-btn', 'site', 'residential', 'Residential', ' data-addon="residential"') +
    choice('addon-btn', 'site', 'commercial', 'Commercial', ' data-addon="residential"'));
  html += ask('forklift', 'Is there a forklift on site to unload it?', yesNo('forklift', '', '', 'liftgate'));
  html += ask('dock', 'Is there a loading dock on site?', yesNo('dock'));
  html += ask('terminal', 'Without a forklift or loading dock the truck cannot be unloaded at your address. ' +
      'Would you like to collect it at the carrier\'s freight terminal near you?',
    yesNo('terminal', 'Yes, terminal pickup', 'No'));
  html += '</div>';
  html += '<div class="gsg-dt-form-slot"></div>';
  html += '<div class="gsg-class-warning gsg-dt-contact" style="display:none;"></div>';
  html += '<div class="delivery-complete-message" style="display:none;">All set! You may now add to cart.</div>';
  body.innerHTML = html;

  if (quoteWrap) body.querySelector('.gsg-dt-form-slot').appendChild(quoteWrap);
  var zipInput = quoteForm ? quoteForm.querySelector('[data-dt-in="5"]') : null;
  if (zipInput) zipInput.setAttribute('pattern', '\\d{5}(-\\d{4})?');

  var el = {
    sent: body.querySelector('.gsg-dt-sent'),
    addons: body.querySelector('.delivery-addons'),
    deliveryNote: body.querySelector('.gsg-dt-delivery-note'),
    pickupNote: body.querySelector('.gsg-dt-pickup-note'),
    path: body.querySelector('.gsg-dt-path'),
    quoteNote: body.querySelector('.gsg-dt-quote-note'),
    orderNote: body.querySelector('.gsg-dt-order-note'),
    site: body.querySelector('[data-dt-step="site"]'),
    forklift: body.querySelector('[data-dt-step="forklift"]'),
    dock: body.querySelector('[data-dt-step="dock"]'),
    terminal: body.querySelector('[data-dt-step="terminal"]'),
    contact: body.querySelector('.gsg-dt-contact'),
    done: body.querySelector('.delivery-complete-message')
  };

  /* Answers. null = not answered yet; forklift/dock/terminal are true/false. */
  var s = {mode: null, path: null, site: null, forklift: null, dock: null, terminal: null};

  /* How the truck gets unloaded: 'forklift' | 'dock' | 'terminal';
     undefined while answering; null when none works (route to a person). */
  function unloading() {
    if (s.forklift === null) return undefined;
    if (s.forklift) return 'forklift';
    if (s.dock === null) return undefined;
    if (s.dock) return 'dock';
    if (s.terminal === null) return undefined;
    return s.terminal ? 'terminal' : null;
  }

  /* undefined = still answering; null = route to a person; object = ready.
     The quote path is ready for its form, never for Add to Cart. */
  function resolve() {
    if (s.mode === 'pickup') return pickup && M.pickup ? {pickup: true, label: M.pickup} : null;
    if (s.mode !== 'delivery' || s.path === null || s.site === null) return undefined;
    var u = unloading();
    if (u === undefined || u === null) return u;
    if (s.path === 'order' && !(flat || M.order_now)) return null;
    return {path: s.path, unload: u, label: flat ? M.flat : M.order_now};
  }
  function canAddToCart(r) { return !!r && (r.pickup || r.path === 'order'); }

  function updatePrice() {
    var basePrice = window.gsgLivePrice(wrapper, basePriceFallback);
    var addons = window.gsgSelectedAddons(wrapper);
    var shown = basePrice + addons.cents / 100;
    window.gsgWritePrice(wrapper, gsgMoney(shown), shown !== basePrice);
    window.gsgRenderAddonNote(wrapper, addons);
    if (buttonPriceEl) {
      buttonPriceEl.innerHTML = '&nbsp;-&nbsp;&nbsp;' + gsgMoney(basePrice * gsgQtyFor(wrapper) + addons.cents / 100);
    }
  }
  window.gsgWireBundleRefresh(wrapper, updatePrice);
  gsgWireQtyRefresh(wrapper, updatePrice);
  window.gsgOnVariantChange(function () { updatePrice(); });

  function show(node, on, display) { if (node) node.style.display = on ? (display || 'block') : 'none'; }

  function render() {
    var delivering = s.mode === 'delivery';
    var pathChosen = delivering && s.path !== null;
    show(el.addons, s.mode !== null);
    show(el.deliveryNote, delivering);
    show(el.pickupNote, s.mode === 'pickup');
    show(el.path, delivering && !flat, 'flex');
    show(el.quoteNote, pathChosen && s.path === 'quote');
    show(el.orderNote, pathChosen && s.path === 'order' && !flat);
    show(el.site, pathChosen);
    show(el.forklift, pathChosen && s.site !== null);
    show(el.dock, pathChosen && s.forklift === false);
    show(el.terminal, pathChosen && s.forklift === false && s.dock === false);
    var r = resolve();
    if (r === null) {
      el.contact.textContent = s.mode === 'delivery' && unloading() === null
        ? 'Daytona equipment has to come off the truck with a forklift or at a loading dock, and no liftgate is available. ' +
          'Call ' + phone + ' or use the chat bubble and we will help you plan the delivery before you order.'
        : 'We arrange this delivery individually. Call ' + phone + ' or use the chat bubble and we will help before you order.';
    }
    show(el.contact, r === null);
    var formOpen = !!r && r.path === 'quote';
    if (quoteWrap) quoteWrap.hidden = !formOpen;
    show(el.done, canAddToCart(r), 'flex');
    window.gsgSetCartButtonState(addToCartBtn, canAddToCart(r));
    updatePrice();
  }

  function mark(key, value) {
    body.querySelectorAll('button[data-dt="' + key + '"]').forEach(function (b) {
      var on = value !== null && b.dataset.value === value;
      b.classList.toggle('selected', on);
      b.setAttribute('aria-pressed', String(on));
    });
  }
  function yn(v) { return v === null ? null : (v ? 'yes' : 'no'); }

  var atcError = null;
  function hideAtcError() { if (atcError) atcError.style.display = 'none'; }
  function showAtcError(message) {
    if (!addToCartBtn) return;
    if (!atcError) {
      atcError = document.createElement('div');
      atcError.className = 'gsg-step-error gsg-atc-error';
      addToCartBtn.insertAdjacentElement('afterend', atcError);
    }
    atcError.textContent = message;
    atcError.style.display = 'block';
    clearTimeout(atcError._t);
    atcError._t = setTimeout(function () { atcError.style.display = 'none'; }, 4500);
  }

  body.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('button[data-dt]') : null;
    if (!b || !body.contains(b)) return;
    var key = b.dataset.dt, value = b.dataset.value, again = b.classList.contains('selected');
    var bool = value === 'yes';
    if (key === 'mode') {
      s = {mode: again ? null : value, path: (flat && !again && value === 'delivery') ? 'order' : null,
           site: null, forklift: null, dock: null, terminal: null};
    } else if (key === 'path') {
      s.path = again ? null : value;
    } else if (key === 'site') {
      s.site = again ? null : value;
    } else if (key === 'forklift') {
      s.forklift = again ? null : bool; s.dock = null; s.terminal = null;
    } else if (key === 'dock') {
      s.dock = again ? null : bool; s.terminal = null;
    } else if (key === 'terminal') {
      s.terminal = again ? null : bool;
    }
    mark('mode', s.mode); mark('path', s.path); mark('site', s.site);
    mark('forklift', yn(s.forklift)); mark('dock', yn(s.dock)); mark('terminal', yn(s.terminal));
    hideAtcError();
    render();
  });

  /* Quote form: copy the answers into the hidden contact fields, then let the
     native contact form submit (Shopify adds its spam check and emails the store). */
  if (quoteForm) {
    quoteForm.addEventListener('submit', function (e) {
      var r = resolve();
      if (!r || r.path !== 'quote' || !quoteForm.checkValidity()) {
        e.preventDefault();
        quoteForm.reportValidity();
        return;
      }
      function put(f, v) { var i = quoteForm.querySelector('[data-dt-f="' + f + '"]'); if (i) i.value = v; }
      function val(n) { var i = quoteForm.querySelector('[data-dt-in="' + n + '"]'); return i ? i.value.trim() : ''; }
      put('site', s.site === 'residential' ? 'Residential' : 'Commercial');
      put('forklift', s.forklift ? 'Yes' : 'No');
      put('dock', s.forklift ? 'Not asked (forklift on site)' : (s.dock ? 'Yes' : 'No'));
      put('terminal', r.unload === 'terminal' ? 'Yes, nearest freight terminal' : 'No');
      put('qty', String(gsgQtyFor(wrapper)));
      put('name', (val(1) + ' ' + val(2)).trim());
    });
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var r = resolve();
      if (!canAddToCart(r)) {
        showAtcError(r === null ? 'This delivery is arranged by phone. See the note above.'
          : (r && r.path === 'quote') ? 'Send the freight quote request above. We will email your quote and invoice.'
          : (s.mode === null ? 'Please choose a delivery method above first.'
                             : 'Please answer the delivery questions above first.'));
        return;
      }
      if (!productForm) { showAtcError('Something went wrong. Please refresh the page.'); return; }
      var variantId = window.gsgSelectedVariantId(productForm);
      if (!variantId) { showAtcError('Please choose an option for this product first.'); return; }

      var props = {'Shipping Type': r.label};
      if (r.pickup) {
        props['Pickup Location'] = pickup.city || r.label;
        props['_gsg_fulfillment_mode'] = 'pickup';
        props['_gsg_pickup_warehouse'] = pickup.key || 'daytona';
      } else {
        props['Delivery Location'] = r.unload === 'terminal' ? 'Freight terminal pickup'
          : (s.site === 'residential' ? 'Residential' : 'Commercial');
        props['_gsg_fulfillment_mode'] = 'delivery';
        props['_gsg_dt_freight'] = flat ? 'flat' : 'quoted_after_order';
        props['_gsg_dt_site'] = s.site;
        props['_gsg_dt_unload'] = r.unload;
        if (receivingClass) props['_gsg_receiving_class'] = receivingClass;
      }

      var items = [{id: variantId, quantity: gsgQtyFor(wrapper), properties: props}];
      window.gsgCollectBundles(wrapper).forEach(function (it) { items.push(it); });
      if (addToCartBtn.dataset.gsgAdding === '1') return;
      addToCartBtn.dataset.gsgAdding = '1';

      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: items})})
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.location.href = '/cart';
        })
        .catch(function (err) {
          delete addToCartBtn.dataset.gsgAdding;
          showAtcError('Could not add to cart: ' + err.message);
        });
    }, true);

    /* The locked button ignores pointer events; route a click on its area to
       the handler above so the shopper sees why it is locked. */
    (addToCartBtn.parentElement || document).addEventListener('click', function (e) {
      if (!addToCartBtn.classList.contains('gsg-cart-locked')) return;
      var rect = addToCartBtn.getBoundingClientRect();
      if (e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom) {
        addToCartBtn.click();
      }
    });
  }

  /* After a quote request posts, Shopify reloads the page: confirm it was sent.
     A failed post reopens the quote path so its error shows. */
  if (wrapper.querySelector('[data-dt-sent]')) show(el.sent, true);
  var postError = quoteForm ? quoteForm.querySelector('.gsg-step-error') : null;
  if (postError) {
    body.insertBefore(postError, body.firstChild);
    s.mode = 'delivery'; s.path = 'quote';
    mark('mode', s.mode); mark('path', s.path);
  }
  render();
});
